import { MoneyFormatterService } from "../services/MoneyFormatterService";
import { FreeRoundsStats } from "../singlegame/singlegame_api";
import { IPublicSimpleBonusTrigger, UnlockRowsConfig } from "./api";
import { JackpotProperties } from "./JackpotProperties";
import { MoneyFromCents } from "./Money";
import { LogGroup, Log, Delay } from "./MyHelpers";
import { Resource } from "./ResourceManager/Resource";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import * as PIXI from 'pixi.js'
import { Settings } from "./Settings";
import { JackpotDisplayProperties } from "./JackpotDisplay/JackpotDisplayProperties";
import { moneyFormatter, MoneyFormatter } from "./MoneyFormatter";
import { service } from "./services";


export const BonusNameMap = {
    "SpinAndHold": "Sticky Spin",
    "ExtendedSpinAndHold": "Extended Sticky Spin",
    "FreeGameBonus": "Free Games",
};


/**
 * declare all messages that the application uses
 * this messages need to be used in all translations
 */
export interface Translation {
    // this is just language information
    locality: string;
    languageEnglish: string;
    language: string;
    localityShort: string;
    // this are messages
    doubleup: string;
    balance: string;
    buyBonusTitle: string;
    buyBonusButton: string;
    jackpotBonusDescription: string;
    doubleBonusDescription: string;
    multiplierBonusDescription: string,
    multibonusCombinedDescription: string,
    rowHelpDescription: string,
    multibonusTitle: string;
    multibonusDescription: string;
    bet: string;
    login: string;
    totalBet: string;
    collect: string;
    spin: string;
    turbo: string;
    menu: string;
    message_pressspin: string;
    message_insertcredit: string;
    message_bonustriggered: string;
    message_goodluck: string;
    maxbet: string;
    doubleUp: string;
    auto: string;
    // lineplay:string;
    // line:string;
    playingOnLines: (lines: number) => string;
    playingDenomOnLines: (denomFormatted: string, lines: number) => string;
    selectedLines: (lines: number) => string;
    denom: string;
    denomOneCredit: string;
    tbet: string;
    tline: string;
    stop: string;
    enableBuyBonus: string;
    buyStickyBonus: string;
    buyStickyBonusConfirmMessage: string;
    buyStickyBonusConfirmMessage2: string;
    price: string;
    betAndCreditsBuybonus: (buyBonusValueString: string, buyBonusCreditsString: string) => string;
    bonusstar: string;
    mailfuncion: string;
    amusement: string;
    win: string;
    lastwin: string;
    paytable: string;
    paylines: string;
    freeGameTitle: string;
    optionsbtntxt: string;
    volumeControlHeader: string;
    speedControlHeader: string;
    minimumbetText: () => string;

    linepay(lineinedex: string, linewin: string): string;
    freeGameHelpDescription(triggerToEnterBonus: string, trigger: string, maxFreeGames: string, wincredits: string, bonusScreen2: string, bonusScreen3: string): string;

    pickbonus(symbol: string): string;
    winbonus(win: string): string;
    rulediamon(diamon: string): string;
    rulediamons(ruby: string, emerald: string, sapphire: string, diamond: string, pot: string): string;
    introfree(): string;


    // expanding wild , reel, common wild help page
    commonWildTitle: string;
    wildReelTitle: string;
    commonwild(wildSymbolImage: string, wildScreen: string, wildScreen2: string): string;
    wildReelDescription(wildSymbolImage: string, freegameSymbolImage: string, pickBonusSymbolImage, wildScreen: string, wildScreen2: string): string;
    wildBulkTitle: string;
    wildBulkDescription(featureTrigger: string, pickImage: string, diamon: string, wildScreen: string, wildScreen2: string): string;
    wildStackDescription(imgBonusTrigger: string, reels: number[]);
    grandJackpotMultiBonusDescription(sraImg: string)
    //Wild Scatter variable was created inside the interface
    wildScatter: string;


    DiamondSpinIntro(spinlogo: string): string;


    diamondPotHelpDescription(trigger: string, pick: string, jp1: string, jp2: string, jp3: string, jp4: string, pot: string, numberOfPicks: string, lastPageNumberOfPicks: string, maxPicks: string): string;

    dragonPotHelpDescription(trigger: string, pick: string, jp1: string, jp2: string, jp3: string, jp4: string, pot: string, numberOfPicks: string, lastPageNumberOfPicks: string, maxPicks: string): string;


    freegameCongratulations: string;
    freeGameYouHaveWon: string;
    freegameFreegame: string;
    freegameBonus: string;
    freegamePressStart: string;
    freegameStart: string;
    freegameExit: string;
    freeGamePickInstruction: string;
    //pickfreegames1:string;
    //pickfreegames2:string;

    freeGameGreat: string;
    freeGameYouHavePicked: string;
    freeGameFreeGames: string;
    freeGamePressStartToBegin: string;

    freeGameFinished: string;
    freeGameCredits: string;
    freeGamePressExit: string;

    welcome: string;
    footer: string;
    level1: string;
    level2: string;
    level3: string;
    level4: string;
    wildBulk: string;

    //bonusinstru:string;
    bonusinstru(maxFreeGames: string);

    levebonus1: string;
    levebonus2: string;
    levebonus3: string;
    levebonus4: string;
    pickleft(pick: number);
    diamondSpinRemaining(spinLeft: number);
    titlefreegame: string;
    totalwin: string;
    won: string;
    played: string;
    left: string;
    wildcommon: string;
    wildreel: string;
    extrafreegame: string;
    extrafreegame2: string;
    notcredit: string;
    goodluck: string;

    // spin and hold
    totalwinHoldAndSpin: string;
    totalleftHoldAndSpin: string;

    // BIGFG
    playedBigFG: string;
    leftbigfg: string;
    freeroundTitle: string;
    freeroundmessage(freeRoundsStat: FreeRoundsStats, betFormated: string): string;
    freerRoundCounterText(freeRoundsRemaining: number): string;


    progressivePickBonus(ruby: string, emerald: string, sapphire: string, diamond: string, pots: string): string;
    //progressivePickBonus: string;

    diamondspinhelp(trigger: string, logo: string, MachineImg: string, gold: string, silver: string, bronze: string, graphite: string): string;

    diamondspinPayTable(brick: string, award: string): string;

    diamondSpinSecondScreenHelp(trigger: string): string;

    HoldAndSpinHelp(trigger: string): string;

    BigFG(textSpanish: string, textEnglish): string;

    HelpInfoTriggerBigFG: string;
    //HelpInfoTriggerBigFG2:string;

    HelpInfoPlusBigFG(triggerValue: number): string;
    HelpInfoPlusFG(triggerValue: number, maxAdditionalFreegames: number): string;
    HelpInfoFGBonusIntoBonus(bonusNameTrigger: string, countSymbolTrigger: number, symbolImgTrigger: string): string;
    //HelpInfoPlusBigFG2:string;
    //HelpInfoPlusBigFG3:string;


    BigHoldAndSpinHelpWin: string;
    BigHoldAndSpinHelpWin2: string;
    BigHoldAndSpinHelpWin3: string;

    HoldAndSpinHelpWin(triggerBonus: number): string;
    HoldAndSpinHelpWin2(fullAwardCount: number): string;


    WildReelDescription: string;
    WildBulkDescription: string;
    WildBulkDescriptionPixi: string;
    WildTriggerBonus: string;
    WildStackFeature: string;
    WildReplaceDescription: string;

    turboDescription: string;
    TitleTurboPlay: string;
    TurboTitle(TitleSpanish, TitleEnglish): string;
    selectGame: string;
    selectDenom: string;
    settingsTitle: string;
    buttonMenuAccept: string;
    buttonMenuCancel: string;
    callAttendant: string;
    extendedSpinAndHoldInfoUnlock: string;
    extendendDiamondSpinRemaining(spinLeft: number);
    extendendLasSpinMessage: string;
    helpInfoExttendedSpinAndHold(trigger: string, triggerCount: number, resetSpinsCount: number, columnsCount: number, rowsCount: number, unlockRowsConfig: UnlockRowsConfig);
    skipMessageCommets: string;
    scatterBonusPaytableMessage(scatterData: IPublicSimpleBonusTrigger);
    wildPaytableMessage(imgBonusTrigger?: string);
    scatterPaysAnywhereMessage: string;
    wildBulkPaytableMessage(reelIndexData: number[], imgBonusTrigger?: string);
    wildReelPaytableMessage(imgBonusTrigger?: string);
    StartingFreegamesHelp(symbolsCount: number, startingFreegames: number, bonusWildSymbolContainer: string);
    doubleUpTitle: string;
    doubleUpHistoryTitle: string;
    doubleUpLastCardTitle: string;
    doubleUpRedCardTxt: string;
    doubleUpBlackCardTxt: string;
    doubleUpCollectBtnTxt: string;
    doubleUpRHalfBetBtnTxt: string;
    doubleUpWinSign: string;
    doubleUpLoseSign: string;
    doubleUpBetLimitSignTxt: string;
    doubleUpSelectedSign: string;
    doubleUpGainTxt: string;
    doubleUpCollectHalfTxt: string;
    doubleUpCollectAllTxt: string;
    doubleUpWinLimitSignTxt(winLimit: string);
    doubleUpBetAndWinTxt(bet: string, win: string);
    doubleUpGameLimitTxt(maxPicks: number);
    doubleUpDescription(winLimit: string);
    spinandHoldInfoHelpFullAward: string;
    fillingPotTitle: string;
    fillingPotDescription: string;

    DialogIntroPixiBonus(textSpanish: PIXI.Texture<PIXI.Resource>, textEnglish: PIXI.Texture<PIXI.Resource>): PIXI.Texture<PIXI.Resource>;
    DialogFinalPixiBonus(textSpanish: PIXI.Texture<PIXI.Resource>, textEnglish: PIXI.Texture<PIXI.Resource>): PIXI.Texture<PIXI.Resource>;

    jackpotSharedDescription: string,

    bonusMultiplierDescription: string,
    backtogametxt: string,
    bonusSpinsRemainingAndTotal(from: number, to: number): string,

    portalBonusDescription: string,
    FillingGrandJackpotMultiBonusDescription(sraImg: string);
    buyBonusDisabledMessage: string;
    symbolPayFeatureSRA(count, bonusName): string,
    fillingJackpotMultiBonusDescription(jackpots: HTMLSpanElement[]): string;
}






/**
 * This is english translation, this will be default language
 */
export const EnglishTranslation: Translation =
{
    locality: "en-US",
    languageEnglish: "English",
    language: "English",
    localityShort: "en",

    balance: "CREDITS",
    buyBonusTitle: "BUY BONUS",
    buyBonusButton: "BUY<br/>BONUS",
    jackpotBonusDescription: "IN JACKPOT BONUS YOU HAVE A CHANCE TO WIN AVAILABLE JACKPOTS YOU CAN WIN MORE JACKPOTS BEING THE SAME OR DIFFERENT BUT YOU ARE GUARANTEED TO WIN MINIMUM 1 OF THEM",
    doubleBonusDescription: "DOUBLE BONUS EXTENDS REELS TO 6 SYMBOLS PER REEL SO YOUR CHANCE TO WIN IS GREATER AND YOUR TOTAL WIN HIGHER",
    multiplierBonusDescription: "MULTIPLIER BONUS MULTIPLIES ALL WINS EXCEPT GRAND JP AND MAJOR JP BY 2, 3 OR 4. WHICH IS DETERMINED WHEN WINNING THE BONUS",
    multibonusCombinedDescription: "YOU CAN WIN ANY COMBINATION OF TWO BONUSES TOGETHER WITH ALL THE BENEFITS FROM BOTH OF THEM",
    rowHelpDescription: "YOU CAN ALSO WIN ALL 3 BONUSES TOGETHER WITH ALL THE BENEFITS FROM ALL 3 OF THEM THE WINS ARE EXPECTACULAR",
    multibonusTitle: "MULTIBONUS",
    multibonusDescription: "4 OR MORE OF ANY OF THESE SYMBOLS WINS THE BONUS. \n THE BONUS CAN ALSO BE WON IN FREE GAMES",
    bet: "Bet",
    totalBet: "Total bet",
    maxbet: "MAX<br/>BET ",
    doubleUp: "DOUBLE<br/>UP",
    auto: "AUTO<br/>PLAY",
    doubleup: "DOUBLE<br/>UP",
    backtogametxt: "BACK TO GAME",

    enableBuyBonus: "Enable buy bonus?",
    betAndCreditsBuybonus: (buyBonusValueString: string, buyBonusCreditsString: string) => "BONUS PRICE : " + buyBonusValueString,

    buyStickyBonus: "BASIC GAME BET : ",
    buyStickyBonusConfirmMessage: "PLEASE CONFIRM THE PURCHASE",
    buyStickyBonusConfirmMessage2: "CONFIRMING THE PURCHASE YOU ARE GRANTED TO WIN A BONUS GAME , WITH ONE OF THE BONUSES AVAILABLE OR ANY COMBINATION OF THEM",

    price: "Price:",

    collect: "REDEEM",
    spin: "PLAY",
    turbo: "TURBO",
    menu: "MORE<br/>GAMES",
    message_pressspin: "Press PLAY to start the game",
    message_insertcredit: "Insert credit",
    message_goodluck: "Good luck!",
    //lineplay:"PLAY",
    //line:"LINES",
    playingOnLines: (lines: number) => `PLAY ${lines} LINES`,
    playingDenomOnLines: (denomFormatted: string, lines: number) => `PLAY ${lines} LINES, DENOM ${denomFormatted}`,
    selectedLines: (lines: number) => `${lines}<span style="white-space:nowrap; transform:rotate(90deg); display:block">LINES</span>`,
    denom: "DENOM",
    denomOneCredit: "1 credit",
    tbet: " PLAY",
    login: "LOGIN",
    tline: "BET/LINE",
    stop: "STOP",
    message_bonustriggered: "Bonus game triggered",
    bonusstar: "Starting bonus game",
    mailfuncion: "Malfunction voids all pays and plays",
    amusement: "Amusement only no cash value",
    win: "WIN",
    lastwin: "LAST WIN",
    paytable: "PAYTABLE",
    paylines: "PAYLINES",
    freeGameTitle: "FREE GAME BONUS",
    optionsbtntxt: "CONFIG",

    DiamondSpinIntro: (spinlogo: string) => `CONGRATULATIONS <br />
    YOU HAVE WON <br />
    ${spinlogo} BONUS <br />
    PRESS START TO BEGIN.`,

    linepay: (linenumber: string, linewinCredits: string) => `Line ${linenumber} pays ${linewinCredits} credits`,

    //free game help page 
    freeGameHelpDescription: (triggerToEnterBonus: string, trigger: string, maxFreeGames: string, wincredits: string, bonusScreen2: string, bonusScreen3: string) =>
        `${triggerToEnterBonus} OR MORE ${trigger} WIN FREEGAME BONUS. WIN UP TO ${maxFreeGames} FREEGAMES.<br />${bonusScreen2}`,

    // diamond pot help page
    diamondPotHelpDescription: (trigger: string, pick: string, jp1: string, jp2: string, jp3: string, jp4: string, pot: string, numberOfPicks: string, lastPageNumberOfPicks: string, maxPicks: string) =>
        ` 3 ${trigger} TRIGGER DIAMOND POT BONUS <br />
        IN DIAMOND POT BONUS YOU HAVE TO OPEN ${numberOfPicks} ${pick}, FROM ${maxPicks} AVAILABLE.<br />
        UNDER THE SYMBOLS ${pick} YOU HAVE PRIZES AND GEMS.
        FINDING AT LEAST ONE GEM: ${jp1}, ${jp2}, ${jp3}, ${jp4}, OF ANY COLOR AND YOU WILL PROCEED TO NEXT LEVEL.<br />
        YOU HAVE 3 LEVELS IN WHICH YOU CAN WIN RUBY, SAPPHIRE AND EMERALD.
        IF YOU FIND 4 DIAMONDS OF SAME COLOR YOU CAN WIN MORE THAN ONE BONUS.<br />
        IF YOU FIND 3 DIAMONDS OF THIS COLOR ${jp4} IN FIRST THREE LEVES YOU WIN SUPER LEVEL.<br />
        WHERE FROM <span class="pickBonus-lastPageNumberOfPicks">&nbsp;${lastPageNumberOfPicks}</span> ${pick} CHOOSE ONLY ONE, YOU HAVE TO FIND FOURTH WHITE DIAMOND.<br />
        AND IF YOU FIND YOU HAVE WON THE ${pot}.<br />
        IF YOU MISS THE BONUS GAME IS OVER.
        `,

    // dragon pot help page
    dragonPotHelpDescription: (trigger: string, pick: string, jp1: string, jp2: string, jp3: string, jp4: string, pot: string, numberOfPicks: string, lastPageNumberOfPicks: string, maxPicks: string) =>
        ` 3 ${trigger} TRIGGER  DRAGON  LINK 
    IN DRAGON LINK YOU HAVE TO OPEN ${numberOfPicks} ${pick}, FROM ${maxPicks} AVAILABLE.<br />
    UNDER THE SIMBOLS ${pick} YOU HAVE PRIZES AND DRAGONS.<br />
    FINDING AT LEAST ONE DRAGON: ${jp1}, ${jp2}, ${jp3}, ${jp4}, OF ANY COLOR AND YOU WILL PROCEED TO NEXT LEVEL.<br />
    YOU HAVE 3 LEVELS IN WHICH YOU CAN WIN MINI BONUS, MINOR BONUS, GRAND JACKPOT AND DRAGON JACKPOT.
    IF YOU FIND 4 DRAGONS OF SAME COLOR YOU CAN WIN MORE THAN ONE BONUS.<br/>
    IF YOU FIND 3 DRAGONS OF THIS COLOR ${jp4} IN FIRST THREE LEVES YOU WIN SUPER LEVEL.<br/>
    WHERE FROM <span class="pickBonus-lastPageNumberOfPicks">&nbsp;${lastPageNumberOfPicks}</span> ${pick} CHOOSE ONLY ONE, YOU HAVE TO FIND FOURTH WHITE DRAGON.<br />
    AND IF YOU FIND YOU HAVE WON THE ${pot}.<br />
    IF YOU MISS THE BONUS GAME IS OVER.
    `,


    pickbonus: (symbol: string) =>
        `PICK 5 ${symbol} IN SEARCH FOR THE TREASURE`,

    winbonus: (win: string) =>
        `CONGRATULATIONS  <br /> YOU HAVE WON <br /> ${win}  <br />Touch the screen to continue`,

    rulediamon: (diamon: string) =>
        `3 ${diamon} OR MORE ANYWHERE OPENS THE DIAMOND<br />&emsp;&emsp;&ensp; POT BONUS AND PAYS  UP TO <span class="upto"> 1250 CREDITS</span><br />
        4 ${diamon} ANYWHERE PAYS UP TO <span class="upto"> 12500 CREDITS</span><br />
        5 ${diamon} ANYWHERE PAYS  UP TO<span class="upto"> 50000 CREDITS</span><br />`,

    introfree: () => `<span class="header" >CONGRATULATIONS </span> <br />YOU HAVE WON<br />FREEGAME<br />BONUS<br />Press START to enter the bonus`,

    commonWildTitle: "WILD",
    commonwild: (wildSymbolImage: string, wildScreen1: string) =>
        `${wildSymbolImage} SUBSTITUTE ALL SYMBOLS  <br />
        ${wildScreen1}
        `,


    wildReelTitle: "EXPANDING WILD REEL",
    wildReelDescription: (wildSymbolImage: string, freegameSymbolImage: string, pickBonusSymbolImage: string, wildScreen: string, wildScreen2: string) =>
        `${wildSymbolImage} EXPANDS OVER ENTIRE REEL OF SYMBOLS. <br />
        IF THERE IS  ${freegameSymbolImage} or ${pickBonusSymbolImage} TRIGGER ON THE SCREEN. <br />
        THE BONUS IS ACTIVATED AFTER THE WILD REPLACES THE SYMBOLS.<br />
        ${wildScreen}`,

    wildBulkTitle: "EXPANDING WILD BULK",
    wildBulkDescription: (featureTrigger: string, pickImage: string, diamon: string, wildScreen: string, wildScree2: string) =>
        ` ${featureTrigger} EXPANDS OVER ALL NEIGHBORING SYMBOLS. <br />
        IF THERE IS  ${pickImage} or ${diamon} TRIGGER ON THE SCREEN. <br />
        THE BONUS IS ACTIVATED AFTER THE WILD REPLACES THE SYMBOLS.<br />
         ${wildScreen}`,
    //Wild with Scatter
    wildScatter: `SUBSTITUTE ALL SYMBOLS\nEXCEPT THE SCATTER`,

    progressivePickBonus: (ruby: string, emerald: string, sapphire: string, diamond: string, pots: string) =>
        `
        INCREASE YOUR BET AND THE CHANCES OF WINNING ${pots} ${sapphire} ${emerald} ${ruby} ${diamond} WILL BE MUCH HIGHER !!!!! 
        `,


    rulediamons: (ruby: string, emerald: string, sapphire: string, diamond: string, pot: string) =>
        `4 ${ruby} WIN RUBY  <br />
        4 ${emerald} WIN EMERALD<br />
        4 ${sapphire} WIN SAPHIRE<br />
        4 ${diamond} WIN ${pot}<br />`,

    played: "PLAYED",
    left: "LEFT",


    bonusinstru: (maxFreeGame: string) =>
        `WIN UP TO ${maxFreeGame} FREE GAMES <br />`,




    // free game into message
    freegameCongratulations: "CONGRATULATIONS",
    freeGameYouHaveWon: "YOU HAVE WON",
    freegameFreegame: "FREEGAME",
    freegameBonus: "BONUS",
    freegamePressStart: "Press START to enter the bonus",
    freegameStart: "START",
    freegameExit: "EXIT",
    freeGamePickInstruction: "PICK THE SYMBOL TO REVEAL THE NUMBER OF FREEGAMES",

    //free game pick info message
    freeGameGreat: "GREAT",
    freeGameYouHavePicked: "YOU HAVE PICKED",
    freeGameFreeGames: "FREGAMES",
    freeGamePressStartToBegin: "Press START to begin ",

    //free game final message
    freeGameFinished: "FREEGAMES FINISHED",
    //endfree2:"You have won",
    freeGameCredits: "CREDITS",
    freeGamePressExit: " PRESS EXIT TO RETURN TO GAME",


    welcome: "WELCOME",
    footer: "TOUCH THE SCREEN TO START",
    level1: "CONGRATULATIONS YOU HAVE REACHED<br /> THE FIRST LEVEL",
    level2: "CONGRATULATIONS YOU HAVE REACHED <br />THE SECOND LEVEL",
    level3: "CONGRATULATIONS YOU HAVE REACHED<br /> THE THIRD LEVEL",
    level4:
        `CONGRATULATIONS .<br />
    FIND THE LAST DIAMOND AND WIN .<br />
    NOW IS YOUR CHANCE.<br />
    GOOD LUCK <br />TOUCH THE SCREEN TO START`,

    wildreel: "EXPANDS OVER REEL SYMBOLS AND SUBSTITUTE ALL SYMBOLS  EXCEPT DIAMONDS AND BONUS",
    wildBulk: "EXPANDS OVER ALL NEIGHBORIING SYMBOLS AND SUBSTITUTE ALL SYMBOLS  EXCEPT DIAMONDS AND BONUS",
    //bonusinstru:"WIN UP TO 15 FREE GAMES <br />",
    levebonus1: "YOU ARE IN FIRST LEVEL. <br />TO ADVANCE REVEAL ATLEAST ONE GEM",
    levebonus2: "YOU ARE IN SECOND LEVEL. <br />TO ADVANCE REVEAL ATLEAST ONE GEM",
    levebonus3: "YOU ARE IN THIRD LEVEL. <br />GOOD LUCK.",
    levebonus4: "CONGRATULATIONS YOU HAVE REACHED THE DIAMOND LEVEL",
    pickleft: (pick: number) => `PICKS LEFT: ${pick}`,
    diamondSpinRemaining: (spinLeft: number) => `SPINS REMAINING: ${spinLeft}`,
    titlefreegame: "FREEGAME BONUS",
    totalwin: "TOTAL WIN",
    won: "WON",
    wildcommon: `SUBSTITUTE ALL SYMBOLS`,
    extrafreegame: "WIN ADITIONAL FREE GAME DURING FREE GAME BONUS ",
    extrafreegame2: "PICK THE SYMBOL TO REVEAL THE NUMBER OF FREE GAMES  ",
    notcredit: "NOT ENOUGH CREDIT",
    goodluck: "GOOD LUCK",
    volumeControlHeader: `SOUND LEVEL`,
    speedControlHeader: `GAME SPEED`,
    minimumbetText: () => `YOU NEED TO BET AT LEAST ${service.moneyFormatter.FormatCurrency(250)}  TO WIN ${JackpotProperties[JackpotDisplayProperties[Settings.JackpotDisplayType].alias]?.jp4?.name} JACKPOT`,

    //progressivePickBonus: "INCREASE YOUR BET AND THE CHANCES OF WINNING POT WILL BE MUCH HIGHER !!!!!",


    diamondspinhelp: (trigger: string, logo: string, MachineImg: string, gold: string, silver: string, bronze: string, graphite: string) =>
        `3 OR MORE ${trigger} WILL TRIGGER ${logo}<br/>
    NUMBER OF ${trigger} ON SCREEN WILL DETERMINE NUMBER OF FREE SPINS. <br/>
    IF YOU COLLECT 3 OF THE SAME ${gold}${silver}${bronze}${graphite} YOU WIN ONE OF JACKPOTS.
    `,

    /* `WITH  3  ${trigger} IT WILL TRIGGER   ${logo}<br/>
    IN ${logo}  THERE WILL BE  ${MachineImg} ONLY YOU HAVE A ONE SPIN .<br/>
    IF WHEN IT REEL STOP YOU HAVE 3  ${gold}${silver}${bronze}${graphite} EQUAL METAL YOU WILL BE THE JACKPOT WINNER OF THE METAL  .<br/>
   
    <div style=" box-sizing: border-box; background-color: rgb(0,0,0,0.5); border-radius: 49px; margin: 0 auto 0 auto;width: 40%; height: 50%; ">
    <br/>
    IF YOU DONT WON 3 EQUAL SYMBOLS, EACH SYMBOLS PAYS:     
    <br/>${gold}= 100 X BET    ${silver}= 80 X BET <br/>
    ${bronze}= 20 X BET  ${graphite}= 5 X BET <br/></div>`,
    */

    diamondspinPayTable: (brick: string, award: string) =>
        `EVERY ONE OF ${brick} PAYS ${award}`,

    diamondSpinSecondScreenHelp: (trigger: string) =>
        `3X ${trigger} AWARD 3 SPINS <br/>
    4X ${trigger} AWARD 4 SPINS <br/>
    5X ${trigger} AWARD 5 SPINS <br/>`,

    totalwinHoldAndSpin: "WINS",
    totalleftHoldAndSpin: "SPINS REMAINING",

    playedBigFG: "PLAYED",
    leftbigfg: "SPINS REMAINING",
    freeroundTitle: "FREE ROUNDS",
    freeroundmessage: (freeRoundsStat: FreeRoundsStats, betFormated: string) => `${freeRoundsStat.FreeRoundsNumber - freeRoundsStat.PlayedFreeRoundsNumber} FREE SPIN(S) REMAINING IN BET ${betFormated}`,
    freerRoundCounterText: (freeRoundsRemaining: number) => `FREE SPINS REMAINING: ${freeRoundsRemaining}`,

    HoldAndSpinHelp: (trigger: string) =>
        `DURING BASE GAME 6 OR MORE ${trigger} TRIGGER THE BONUS. <br/>
    THE  ${trigger} IN BASE GAME STAYS IN ITS POSITION FOR START STICKY SPIN BONUS.<br/>
    3 SPINS ARE INITIALLY GRANTED.<br/>
    EVERY ONE OR MORE ${trigger} THAT APPEAR DURING BONUS SPIN ALSO GETS STUCK AND THE REMAINING SPINS RETURN TO 3.<br/>
    THE STICKY SPIN BONUS IS FINISHED WHEN YOU ARE OUT OF SPINS OR THE DIAMOND JACKPOT IS WON. <br/>
    ALL THE PRIZES ON ${trigger} ARE AWARDED AT THE END OF THE STICKY SPIN BONUS. <br/>
    PAYTABLE PRIZES ARE NOT AWARDED DURING THE STICKY SPIN BONUS.
    `,


    BigFG: (textSpanish: string, textEnglish) =>
        `${textEnglish}`,

    HelpInfoTriggerBigFG: `WITH 3 OR MORE BONUS SYMBOLS \n 
    WIN FREE GAMES.`,
    //HelpInfoTriggerBigFG2:"WIN FREE GAMES",


    HelpInfoPlusBigFG: (triggerValue: number) => `DURING FREE GAMES \n 
    EVERY BIG BONUS SYMBOL \n
    ADDS YOU ${triggerValue} ADDITIONAL FREE GAMES.`,

    HelpInfoPlusFG: (triggerValue: number, maxAdditionalFreegames: number) => `DURING FREE GAMES \n 
    EVERY BONUS SYMBOL \n
    ADDS YOU ${triggerValue} ADDITIONAL FREE GAMES\n 
    MAXIMUM ADITIONAL ${maxAdditionalFreegames} FREE GAMES.`,

    HelpInfoFGBonusIntoBonus: (bonusNameTrigger: string, countSymbolTrigger: number, symbolImgTrigger: string) => `DURING FREE GAMES \n 
    ${countSymbolTrigger} X ${symbolImgTrigger} OR MORE  \n
    TRIGGER ${bonusNameTrigger}.`,
    //HelpInfoPlusBigFG2:"EVERY BIG BONUS SYMBOL",
    // HelpInfoPlusBigFG3:"ADDS YOU 3 ADDITIONAL FREE GAMES",


    BigHoldAndSpinHelpWin:
        `DURING FREE GAMES\n
    BIG SCATTER SYMBOL TRIGGERS STICKY SPIN BONUS.\n
    3 SPINS ARE GRANTED INITIALLY.`,
    BigHoldAndSpinHelpWin2:
        `ONE OR MORE SCATTER THAT APPEAR DURING BONUS SPIN \n
    ALSO GETS STUCK AND THE RAMAINING SPINS RETURN TO 3.\n
    THE BONUS IS FINISHED \n
    WHEN YOU ARE OUT OF SPINS OR THE DIAMOND JACKPOT IS WON.`,
    BigHoldAndSpinHelpWin3:
        `ALL THE PRIZES ON  ARE AWARDED\n
    AT THE END OF THE STICKY SPIN BONUS.\n
    PAYTABLE PRIZES\n
    ARE NOT AWARDED DURING THE STICKY SPIN BONUS.`,



    HoldAndSpinHelpWin: (triggerBonus: number) =>
        `DURING BASE GAME ${triggerBonus} OR MORE SCATTERS TRIGGER THE BONUS.\n
     IN BASE GAME STAYS STUCK IN ITS POSITION FOR  START STICKY SPIN BONUS.\n
    3 SPINS ARE GRANTED INITIALLY.`,
    HoldAndSpinHelpWin2: (fullAwardCount: number) =>
        `EACH OF THE SCATTERS THAT APPEAR DURING BONUS SPIN \n
    ARE STUCK AND THE RAMAINING SPINS RETURN TO 3.\n
    THE BONUS IS FINISHED \n
    WHEN YOU ARE OUT OF SPINS OR WHEN YOU WIN THE JACKPOT BY GATHERING ${fullAwardCount} SCATTERS.`,

    WildBulkDescription: "EXPANDS OVER ALL NEIGHBOUR SYMBOLS.",
    WildBulkDescriptionPixi: "EXPANDS OVER ALL NEIGHBOUR SYMBOLS.",
    WildReelDescription: "EXPANDS OVER ENTIRE REEL OF SYMBOLS.",
    WildTriggerBonus: "IF THERE ARE ANY OF THIS SYMBOLS \n ON THE SCREEN IT DOES NOT REPLACE THEM .",
    WildReplaceDescription: "IF YOU WIN A BONUS AND THE\nWILD IN THE SAME GAME\nTHE BONUS WILL BE ACTIVATED\nAFTER THE WILD REPLACES THE SYMBOLS",

    turboDescription: `
    FOR EXTREMELY FAST AND EXCITING GAME YOU CAN TURN TURBO ON PLAY \n
    THE BASE GAME WILL RUN VERY FAST UNTIL A BIGGER WIN OR A BONUS IS WON \n
    TO TURN IT ON  PRESS THE START BUTTON FOR AT LEAST 3 SECONDS AND THEN KEEP IT PRESSED\n
    RELEASING THE START BUTTON WILL TURN OFF TURBO GAME IMMEDIATELY`,

    TitleTurboPlay: 'TURBO PLAY',

    TurboTitle: (TitleSpanish: string, TitleEnglish) =>
        `${TitleEnglish}`,

    selectGame: `SELECT GAME`,
    selectDenom: `CHOOSE DENOMINATION`,
    settingsTitle: `GAME CONFIGURATION`,
    buttonMenuAccept: "ACCEPT",
    buttonMenuCancel: "CANCEL",
    callAttendant: "CALL ATTENDANT",
    extendedSpinAndHoldInfoUnlock: "MORE TO UNLOCK",
    extendendDiamondSpinRemaining: (spinLeft: number) => `SPINS REMAINING: ${spinLeft}`,
    extendendLasSpinMessage: "LAST SPIN",
    helpInfoExttendedSpinAndHold: (trigger: string, triggerCount: number, resetSpins: number, columns: number, rows: number, unlockRowsConfig: UnlockRowsConfig) => {



        let rowsIncrementing = [...unlockRowsConfig.Rows].sort((a, b) => a.Unlock - b.Unlock)
        let startText = rowsIncrementing.map((r, i) => ` WHIT ${rows - rowsIncrementing.length + i + 1} UNLOCKED ROWS WHEN TRIGGERED WITH ${unlockRowsConfig.BaseCount + r.Unlock}  ${trigger} `).join(", ");

        return `
        ${triggerCount} OR MORE SCATTERED  ${trigger} TRIGGERS THE EXTENDED STICKY SPIN.\n
        THE FEAUTURE STARTS WITH ${rows - unlockRowsConfig.Rows.length} UNLOCKED ROWS WHEN TRIGGERED WITH ${triggerCount}, ${startText}.

        ${resetSpins} SPINS ARE AWARDED.\n
        ALL ${trigger} SYMBOLS LOCK IN PLACE FOR THE DURATION OF THE FEATURE AND REMAINING SYMBOLS SPIN INDEPENDENTLY.\n
        IF A NEW ${trigger} APPEARS, THE SYMBOL LOCKS IN PLACE FOR THE DURATION OF THE FEATURE.\n
        THE NUMBER OF SPINS REMAINING RESETS TO ${resetSpins} WITH EACH NEWLY LOCKED ${trigger} THAT APPEARS ON AN UNCLOCKED ROW.\n
        COLLECTING THE INDICATED NUMBER OF ADDITIONAL ${trigger} IN UNCLOKED ROWS UNLOCKS THAT ADDITIONAL ROW.\n
        TO WIN THE DIAMOND POT YOU NEED TO COLLECT ALL ${rows * columns} ${trigger}.        
        YOU CAN SPEED UP THE WIN COUNT IN BONUS BY PRESSING START`
    },
    skipMessageCommets: "Skip to Next Comet Press Start",

    scatterBonusPaytableMessage: (scatterData: IPublicSimpleBonusTrigger) => `${scatterData.Count} OR MORE SCATTERS \n WILL TRIGGER ${transformNameBonus(EnglishTranslation.language, scatterData.BonusName).toUpperCase()} `,
    wildPaytableMessage: (imgBonusTrigger?: string) => `WILD ON REELS 1, 3, 5 \n SUBSTITUES ALL \n ${imgBonusTrigger} STILL AWARDED `,
    scatterPaysAnywhereMessage: `PAYS ANYWHERE`,
    wildBulkPaytableMessage: (reelIndexData, imgBonusTrigger?: string) => `WILD APPEARS ON REELS ${reelIndexData} \n AND EXPANDS TO ALL NEIGHBORS \n SYMBOLS AND SUBSTITUTES  FOR ALL SYMBOLS EXCEPT SCATTERS <br>${imgBonusTrigger}`,
    wildReelPaytableMessage: (imgBonusTrigger?: string) => `WILD APPEARS ON ALL REELS AND EXPANDS TO ALL SYMBOLS ON THE SAME REEL AND SUBSTITUTES FOR ALL SYMBOLS EXCEPT SCATTERS <br>${imgBonusTrigger}`,
    StartingFreegamesHelp: (symbolsCount: number, startingFreegames: number, bonusWildSymbolContainer: string) => `IF YOU WIN ${bonusWildSymbolContainer} X ${symbolsCount} , YOU WILL PLAY ${startingFreegames} FREE SPINS.`,
    doubleUpTitle: `DOUBLE UP GAME`,
    doubleUpHistoryTitle: `HISTORY`,
    doubleUpLastCardTitle: `LAST CARD`,
    doubleUpRedCardTxt: `RED`,
    doubleUpBlackCardTxt: `BLACK`,
    doubleUpCollectBtnTxt: `COLLECT`,
    doubleUpRHalfBetBtnTxt: `COLLECT HALF`,
    doubleUpWinSign: `YOU WIN`,
    doubleUpLoseSign: `BETTER LUCK NEXT TIME`,
    doubleUpSelectedSign: `SELECTED!`,
    doubleUpGainTxt: `LAST WIN`,
    doubleUpCollectHalfTxt: `COLLECT HALF`,
    doubleUpBetLimitSignTxt: `WIN LIMIT EXCEEDED! `,
    doubleUpWinLimitSignTxt: (winLimit: string) => `WIN LIMIT ${winLimit}`,
    doubleUpCollectAllTxt: `COLLECT ALL`,
    doubleUpBetAndWinTxt: (bet, win) => `PICK COLOR AND BET ${bet} TO WIN ${win}`,

    doubleUpGameLimitTxt: (maxPicks) => `MAXIMUM ${maxPicks} ATTEMPS`,
    doubleUpDescription: (winLimit: string) => `GUESS THE COLOR OF THE CARD THAT APPEARS IN THE MIDDLE. IF YOU DO IT YOU WOULD BE ABLE TO DOUBLE YOUR WIN, IF NOT, YOU LOSE EVERYTHING! IF IN THE NEXT ROUND YOUR WIN EXCEEDS ${winLimit} THEN THE CURRENT WIN WILL BE AUTOMATICALLY COLLECTED. YOU CAN COLLECT HALF OF YOUR BET IF YOU SELECT THE COLLECT HALF BUTTON OR COLLECT YOUR ENTIRE BET IF YOU SELECT COLLECT ALL BUTTON. IF YOU PRESS COLLECT ALL BUTTON OR YOU LOSE GAME ENDS`,


    wildStackDescription: (imgBonusTrigger?: string) => `${imgBonusTrigger} ON REELS 1, 3, 5 \n SUBSTITUES ALL SYMBOLS. `,
    grandJackpotMultiBonusDescription: (sraImg: string) => `TO WIN THE GRAND JACKPOT YOU NEED TU WIN 15 OR 30 OF ${sraImg} DEPENDING WHICH BONUS OR COMBINATION OF BONUSES YOU HAVE BEEN AWARDED`,
    spinandHoldInfoHelpFullAward: `ALL THE PRICES THAT APPEAR ON SCREEN WILL BE PAID`,

    WildStackFeature: `DOES NOT SUBSTITUES`,
    fillingPotTitle: `FILLING POT`,
    fillingPotDescription: `FILLING POT IS AN CUMULATIVE ANIMATION. THE MORE FULL OR COMPLETE IT ITS, THE CLOSER THE BONUS. EVERY BET KEEPS ITS OWN LEVEL OF ANIMATION. PLAYING THE GAME CAN INCREMENT THE LEVEL OF ANIMATION FOR THE BET PLAYED. WINNING THE BONUS RESETS THE ANIMATION TO THE START FOR THE BET PLAYED.`,
    DialogIntroPixiBonus: (textSpanish, textEnglish) => { return textEnglish },
    DialogFinalPixiBonus: (textSpanish, textEnglish) => { return textEnglish },

    jackpotSharedDescription: `AMOUNT IN SHARED JACKPOT WILL BE DISTRIBUTED AMONG ALL THE PLAYERS PLAYING AT THE MOMENT OF WINNING THE MAIN JACKPOT PROPORTIONALY BASED ON THE LAST BET.`,

    bonusMultiplierDescription: `WHEN SHOWN ON SCREEN, NEXT STICKY BONUS WILL BE MULTIPLIED BY X2 OR X3 ON ALL BONUS WINS IF YOU CONTINUE ON SAME BET AND SAME DENOMINATION. THE JACKPOTS TO BE MULTIPLIED WILL BE MINOR AND MINI IF YOU GET THEM.`,
    bonusSpinsRemainingAndTotal: (from: number, to: number) => `Spin ${from} de ${to}`,
    portalBonusDescription: `IN THE PORTAL BONUS, SPECIAL SYMBOL “PORTAL” APPEAR.
    WHEN A PORTAL SYMBOL LANDS ON THE REELS, IT ACTIVATES THE PORTAL IN THAT POSITION.
    THE PORTAL ABSORBS ALL LOCKED SYMBOLS FROM THE OTHER REELS AND RELEASES THEM FOR NEW PRIZES.
    ALL THE VALUES OF THE ABSORBED SYMBOLS ARE ADDED TO THE PORTAL.
    THE PORTAL THEN BECOMES AN ACCUMULATED SYMBOL WITH THE TOTAL COMBINED VALUE.`,
    FillingGrandJackpotMultiBonusDescription: (sraImg: string) => `TO WIN THE GRAND JACKPOT
     \n  YOU NEED TO COLLECT 6 ${sraImg} GRAND  \n  
     ITS POSIBLE WIN 1 OR MORE GRAND JACKPOT IN THE SAME BONUS.`,
    buyBonusDisabledMessage: `IF THE BUY BONUS BUTTON IS GRAY YOU CAN'T BUY BONUS WITH THE SELECTED BET`,
    symbolPayFeatureSRA: (count, bonusName) => `${count} OR MORE \n ACTIVATES THE BONUS ${bonusName}`,

    fillingJackpotMultiBonusDescription: (jackpots: HTMLSpanElement[]) =>
        `THERE ARE ${jackpots.length} JACKPOTS LEVELS: ${jackpots.filter(Boolean).map(jackpot => jackpot.outerHTML).join(", ")}.

    DURING THE BONUS, SRA JACKPOT SYMBOLS MAY APPEAR ON THE REELS.
    EACH SRA SYMBOL TURNS INTO A COMET THAT FLIES TO ITS JACKPOT AND FILLS ITS METER.

    EACH JACKPOT HAS DIFFERENT CONTAINERS TO FILL. WHEN YOU FILL THEM ALL: YOU WIN THAT JACKPOT! 
    THE REEL WHERE THE SRA SYMBOL LANDED IS RELEASED AND CAN KEEP GIVING MORE JACKPOTS OR PRIZES.

    YOU CAN WIN MULTIPLE JACKPOTS IN A SINGLE BONUS! `
}



/********************************************************************************************/

/**
 * This is the spanish translation
 */
export const SpanishTranslation: Translation =
{
    locality: "es-MX",
    languageEnglish: "Spanish",
    language: "Espanol",
    localityShort: "es",
    doubleup: "DOBLAR",
    backtogametxt: "REGRESAR A JUEGO",

    enableBuyBonus: "Activar compra de bono?",
    betAndCreditsBuybonus: (buyBonusValueString: string, buyBonusCreditsString: string) => "PRECIO DEL BONO : " + buyBonusValueString,

    buyStickyBonus: "APUESTA DE JUEGO BASE : ",
    buyStickyBonusConfirmMessage: "CONFIRMA TU COMPRA ",
    buyStickyBonusConfirmMessage2: "CONFIRMANDO LA COMPRA ESTAS GARANTIZANDO GANAR UN JUEGO DE BONUS O CUALQUIER COMBINACION DE ELLOS",
    price: "Precio:",


    balance: "CREDITOS",
    buyBonusTitle: "COMPRA BONO",
    buyBonusButton: "COMPRA<br />BONO",
    jackpotBonusDescription: "EN JACKPOT BONUS TIENES LA OPORTUNIDAD DE GANAR LOS JACKPOTS DISPONIBLES PUEDES GANAR MAS JACKPOTS IGUALES O DIFERENTES PERO TE GARANTIZAN QUE GANES MINIMO 1 DE ELLOS",
    doubleBonusDescription: "EL DOBLE BONO EXTIENDE LOS RIELES A 6 SIMBOLOS POR RIEL PARA QUE TU OPORTUNIDAD DE GANAR SEA MAYOR Y POR LO TANTO TU GANANCIA TOTAL SEA MAYOR TAMBIEN",
    multiplierBonusDescription: "EL BONO MULTIPLICADOR MULTIPLICA TODAS LAS GANANCIAS EXCEPTO GRAND JP Y MAJOR JP POR 2, 3 O 4. LO CUAL SE DETERMINA AL GANAR EL BONO",
    multibonusCombinedDescription: "PUEDES GANAR CUALQUIER COMBINACION DE DOS BONOS JUNTOS CON TODOS LOS BENEFICIOS DE AMBOS",
    rowHelpDescription: "TAMBIEN PUEDES GANAR LOS 3 BONUS JUNTOS CON TODOS LOS BENEFICIOS, LAS GANANCIAS SON ESPECTACULARES",
    multibonusTitle: "MULTIBONO",
    multibonusDescription: "CON 4 O MAS DE CUALQUIERA DE ESTOS SIMBOLOS SE GANA EL BONO. \n EL BONO SE PUEDE GANAR TAMBIEN EN JUEGOS GRATIS",
    bet: "Bet",
    totalBet: "APUESTA TOTAL ",
    maxbet: "APUESTA<br />MAXIMA",
    doubleUp: "DOBLE<br />GANADO",
    auto: "AUTO <br />JUEGO",
    collect: "COBRAR",
    spin: "JUGAR",
    turbo: "TURBO",
    menu: "MAS<br/>JUEGOS",
    message_pressspin: "Presiona Jugar para Iniciar",
    message_insertcredit: "Inserta créditos",
    message_goodluck: "Buena suerte",
    // lineplay:"JUGANDO",
    // line:"LINEAS",
    playingOnLines: (lines: number) => `JUGANDO ${lines} LINEAS`,
    playingDenomOnLines: (denomFormatted: string, lines: number) => `JUGANDO ${lines} LINEAS, DENOM ${denomFormatted}`,
    selectedLines: (lines: number) => `${lines} <span style="white-space:nowrap; display:block">L</span>
    <span style="white-space:nowrap; display:block">I</span>
    <span style="white-space:nowrap; display:block">N</span>
    <span style="white-space:nowrap; display:block">E</span>
    <span style="white-space:nowrap; display:block">A</span>
    <span style="white-space:nowrap; display:block">S</span>`,
    denom: "DENOM",
    denomOneCredit: "1 crédito",
    tbet: " APUESTA",
    login: "LOGIN",
    tline: "APUESTA/LINEA",
    stop: "DETENER",
    message_bonustriggered: "Juego de bonificacion activado",
    bonusstar: "Iniciando Juego de Bono",
    mailfuncion: "El mal funcionamiento   anula todos los pagos y jugadas",
    amusement: "Entretenimiento solo sin valor monetario",
    win: "GANASTE",
    lastwin: "ULTIMO GANADO",
    paytable: "TABLA DE PAGOS",
    paylines: "LINEAS DE PAGOS",
    freeGameTitle: "JUEGOS GRATIS",
    optionsbtntxt: "CONFIG",
    volumeControlHeader: `VOLUMEN`,
    speedControlHeader: `VELOCIDAD DE JUEGO`,
    minimumbetText: () => `TIENES POSIBILIDADES DE GANAR EL JACKPOT ${JackpotProperties[JackpotDisplayProperties[Settings.JackpotDisplayType].alias]?.jp4?.name} APOSTANDO DESDE ${service.moneyFormatter.FormatCurrency(250)}`,

    linepay: (lineinedex: string, linewin: string) =>
        'Linea ' + "  " + lineinedex + " " + 'paga' + " " + linewin + " " + 'creditos',
    freeGameHelpDescription: (triggerToEnterBonus: string, trigger: string, maxFreeGames: string, wincredits: string, bonusScreen2: string, bonusScreen3: string) =>
        `CON ${triggerToEnterBonus} O MAS ${trigger} USTED PUEDE GANAR HASTA ${maxFreeGames} JUEGOS GRATIS . <br />${bonusScreen3}`,


    diamondPotHelpDescription: (trigger: string, pick: string, jp1: string, jp2: string, jp3: string, jp4: string, pot: string, numberOfPicks: string, lastPageNumberOfPicks: string, maxPicks: string) =>
        `
         3 ${trigger}  DIAMOND POT BONUS<br />
        EN DIAMOND POT BONUS USTED TIENE QUE ABRIR ${numberOfPicks} ${pick}, DE ${maxPicks} DISPONIBLES.<br />
        DEBAJO DE CADA SIMBOLO DE ${pick}  HAY PREMIOS FIJOS O GEMAS.<br />
        ENCONTRANDO AL MENOS UNA GEMA: ${jp1}, ${jp2}, ${jp3}, ${jp4}, PODRA PASAR AL SIGUIENTE NIVEL.<br />
        TIENE 3 NIVELES PARA GANAR EL ACUMULADO SAPPHIRE, EMERALD, RUBY Y DIAMOND.<br />
        SI ENCUENTRA 4 DIAMANTES DEL MISMO COLOR SERA ACREEDOR AL VALOR INDICADO.<br />
        SI USTED ENCUENTRA 3  ${jp4} EN LOS 3 PRIMEROS NIVELES SE ABRIRA  UN SUPER NIVEL.<br />
        EN ESTE SUPER NIVEL HAY <span class="pickBonus-lastPageNumberOfPicks">&nbsp;${lastPageNumberOfPicks}</span> ${pick} CON SOLO UNA POSIBILIDAD DE ELEGIR EL CUARTO ${jp4} <br />
        Y SER ACREDOR A ${pot}. SI NO ES ENCONTRADO FINALIZA EL SUPER NIVEL.
        `,


    dragonPotHelpDescription: (trigger: string, pick: string, jp1: string, jp2: string, jp3: string, jp4: string, pot: string, numberOfPicks: string, lastPageNumberOfPicks: string, maxPicks: string) =>
        `
         3 ${trigger}  DRAGON LINK <br />
        EN DRAGON LINK USTED TIENE QUE ABRIR ${numberOfPicks} ${pick}, DE ${maxPicks} DISPONIBLES.<br />
        DEBAJO DE CADA SIMBOLO DE ${pick}  HAY PREMIOS FIJOS O DRAGONES.<br />
        ENCONTRANDO AL MENOS UN DRAGON: ${jp1}, ${jp2}, ${jp3}, ${jp4}, PODRA PASAR AL SIGUIENTE NIVEL.<br />
        TIENE 3 NIVELES PARA GANAR EL ACUMULADO MINI BONUS, MINOR BONUS , GRAND JACKPOT  Y DRAGONS JACKPOT .<br />
        SI ENCUENTRA 4 DRAGONES DEL MISMO COLOR SERA ACREEDOR AL VALOR INDICADO.<br />
        SI USTED ENCUENTRA 3  ${jp4} EN LOS 3 PRIMEROS NIVELES SE ABRIRA  UN SUPER NIVEL.<br />
        EN ESTE SUPER NIVEL HAY <span class="pickBonus-lastPageNumberOfPicks">&nbsp;${lastPageNumberOfPicks}</span> ${pick} CON SOLO UNA POSIBILIDAD DE ELEGIR EL CUARTO ${jp4} <br />
        Y SER ACREDOR A ${pot}. SI NO ES ENCONTRADO FINALIZA EL SUPER NIVEL.
        `,

    pickbonus: (symbol: string) =>
        ` SELECCIONA 5 ${symbol} EN BUSCA DEL TESORO `,

    winbonus: (win: string) =>
        `FELICITACIONES  <br /> USTED GANO  <br /> ${win} <br />Presiona para continuar `,

    rulediamon: (diamon: string) =>
        `3 ${diamon}O MAS EN CUALQUIER LUGAR ABRE EL DIAMOND<br />&emsp;&emsp;&ensp; POT BONUS Y PAGA HASTA <span class="upto"> 1250 CREDITOS</span><br />
        4 ${diamon} PAGA HASTA <span class="upto"> 12500 CREDITOS</span><br />
        5 ${diamon} PAGA HASTA  <span class="upto"> 50000 CREDITOS</span><br />`,

    introfree: () => `<span class="header" >FELICIDADES</span><br/>HAS GANADO<br />JUEGOS GRATIS<br />BONO<br />Presiona INICAR para entrar el bonos`,

    commonWildTitle: "WILD",
    commonwild: (wildSymbolImage: string, wildScreen2: string) =>
        `${wildSymbolImage}   SUSTITUYE TODOS LOS SIMBOLOS <br />
         ${wildScreen2}`,


    wildReelTitle: "EXPANDING WILD REEL",
    wildReelDescription: (wildSymbolImage: string, freegameSymbolImage: string, pickBonusSymbolImage: string, wildScreen: string, wildScreen2: string) =>
        ` ${wildSymbolImage}  SE EXPANDE SOBRE  TODO RIEL. <br />
        SI HAY UN   ${freegameSymbolImage} O ${pickBonusSymbolImage} EN LA PANTALLA .  <br />
        EL BONUS SE ACTIVA DESPUES DE QUE EL WILD SUSTITUYE LOS SIMBOLOS.<br />
        ${wildScreen2}`,
    //Wild with Scatter
    wildScatter: `SUSTITUYE TODOS LOS SIMBOLOS\nEXCEPTO EL SCATTER`,

    rulediamons: (ruby: string, emerald: string, sapphire: string, diamond: string, pot: string) => `
        CON 4 ${ruby} GANE  RUBY<br />
        CON 4 ${emerald} GANE EMERALD     <br />
        CON 4 ${sapphire} GANE SAPPHIRE<br />
        CON 4 ${diamond} GANE DIAMOND ${pot}<br />`,

    wildBulkTitle: "EXPANDING WILD BULK",
    wildBulkDescription: (featureTrigger: string, pickImage: string, diamon: string, wildScreen: string, wildScreen2: string) =>
        `CADA ${featureTrigger} SE EXPANDE SOBRE TODOS LOS SIMBOLOS VECINOS. <br />
        SI HAY UN  ${pickImage} O ${diamon} EN LA PANTALLA . <br />
        EL BONUS SE ACTIVA DESPUES DE QUE EL WILD SUSTITUYA LOS SIMBOLOS.<br />
        ${wildScreen2}`,

    played: "JUGADOS",
    left: "RESTANTES",


    DiamondSpinIntro: (spinlogo: string) => `   FELICIDADES HA GANADO
        EL BONO ${spinlogo}<br />
        PRESIONE INICIAR PARA COMENZAR.
    `,

    freegameCongratulations: "FELICIDADES",
    freeGameYouHaveWon: "HAS GANADO ",
    freegameFreegame: "JUEGOS GRATIS",
    freegameBonus: "BONO",
    freegamePressStart: " Presiona INICAR para empezar el bonus",
    freegameStart: "INICIAR",
    freegameExit: "SALIR",
    freeGamePickInstruction: "ELIJA EL SIMBOLO PARA REVELAR EL NUMERO DE JUEGOS GRATIS",
    //pickfreegames2:" PARA REVELAR EL NUMERO DE JUEGOS GRATIS",


    freeGameGreat: "GENIAL",
    freeGameYouHavePicked: "HAS ESCOGIDO",
    freeGameFreeGames: "JUEGOS GRATIS",
    freeGamePressStartToBegin: "PRESIONA INICIAR para comenzar ",



    freeGameFinished: "FIN DE JUEGOS GRATIS ",
    //endfree2:"USTED HA GANADO ",
    freeGameCredits: "CREDITOS",
    freeGamePressExit: "PRESIONA SALIR PARA REGRESAR AL JUEGO",
    welcome: "BIENVENIDO",
    footer: "Presione pantalla para iniciar ",
    level1: " FELICIDADES HAS ALCANZADO EL 1 NIVEL",
    level2: " FELICIDADES HAS ALCANZADO EL 2 NIVEL",
    level3: " FELICIDADES HAS ALCANZADO EL 3 NIVEL",

    level4:
        `FELICIDADES .<br />
    ENCUENTRA EL ULTIMO DIAMANTE Y GANA.<br />
    ES TU OPORTUNIDAD.<br />
    BUENA SUERTE  <br />TOCA LA PANTALLA PARA COMENZAR`, //test


    wildreel: "SE EXPANDE SOBRE TODO EL RIEL Y SUSTITUYE TODOS LOS SIMBOLOS  EXCEPTO DIAMANTES Y BONOS",
    wildBulk: "SE EXPANDE SOBRE TODOS LOS VECINOS Y SUSTITUYE TODOS LOS SIMBOLOS  EXCEPTO DIAMANTES Y BONOS .",

    bonusinstru: (maxFreeGame: string) =>
        `GANE HASTA ${maxFreeGame} JUEGOS GRATIS <br />`,

    //bonusinstru:"GANE HASTA 15 JUEGOS GRATIS <br />",
    levebonus1: "ESTAS EN EL PRIMER NIVEL. <br />PARA AVANZAR AL PROXIMO NIVEL ENCUENTRA POR LO MENOS UNA GEMA",
    levebonus2: "ESTAS EN EL SEGUNDO NIVEL. <br />PARA AVANZAR AL PROXIMO NIVEL ENCUENTRA POR LO MENOS UNA GEMA",
    levebonus3: "LLEGASTE AL TERCER NIVEL<br /> BUENA SUERTE  ",
    levebonus4: "FELICIDADES QUE HAN ALCANZADO EL NIVEL DE DIAMANTE",
    pickleft: (pick: number) => `RESTANTES: ${pick}`,
    diamondSpinRemaining: (spinLeft: number) => `SPINS RESTANTES: ${spinLeft}`,
    titlefreegame: "BONO JUEGOS GRATIS ",
    totalwin: "TOTAL GANADO",
    won: "GANADO",
    wildcommon: `SUSTITUYE TODOS\nLOS SIMBOLOS`,
    extrafreegame: "GANA JUEGOS GRATIS ADICIONALES DURANTE FREE GAME BONUS ",
    extrafreegame2: "ELIJA EL SIMBOLO PARA REVELAR EL NUMERO DE JUEGOS GRATIS ",
    notcredit: "CREDITO INSUFICIENTE",
    goodluck: "BUENA SUERTE ",


    progressivePickBonus: (ruby: string, emerald: string, sapphire: string, diamond: string, pots: string) =>
        `
        AUMENTA TU APUESTA Y LAS POSIBILIDADES DE GANAR EL ${pots} ${sapphire} ${emerald} ${ruby} ${diamond} SERAN MAYORES !!!!! 
    `,
    //progressivePickBonus: "AUMENTA TU APUESTA Y LAS POSIBILIDADES DE GANAR POT SERAN MAYORES !!!!! ",


    diamondspinhelp: (trigger: string, logo: string, MachineImg: string, gold: string, silver: string, bronze: string, graphite: string) =>
        `3 OR MORE ${trigger} WILL TRIGGER ${logo}<br/>
    NUMBER OF ${trigger} ON SCREEN WILL DETERMINE NUMBER OF FREE SPINS. <br/>
    IF YOU COLLECT 3 OF THE SAME ${gold}${silver}${bronze}${graphite} YOU WIN ONE OF JACKPOTS.
    `,


    /* diamondspinhelp:(trigger:string,logo:string,MachineImg:string,gold:string,silver:string,bronze:string,graphite:string)=>
    `CON  3  ${trigger} SE ACTIVARA ${logo}<br/>
    EN ${logo} HABRA UNA ${MachineImg} DONDE  SE TENDRA UNA OPORTUDIDAD DE GIRO.<br/>
    SI AL DETENERSE OBTIENE 3 ${gold}${silver}${bronze}${graphite} METALES IGUALES SERA ACREEDOR AL VALOR DEL JACKPOT DE ESE METAL.<br/>
   
    <div style=" box-sizing: border-box; background-color: rgb(0,0,0,0.5); border-radius: 49px; margin: 0 auto 0 auto;width: 40%; height: 50%; ">
    <br/>
    SI NO TIENES 3 IGUALES CADA SIMBOLO PAGA:     
    <br/>${gold}= 100 X APUESTA    ${silver}= 80 X APUESTA <br/>
    ${bronze}= 20 X APUESTA  ${graphite}= 5 X APUESTA <br/></div>`, */


    diamondspinPayTable: (brick: string, award: string) =>
        `EVERY ONE OF ${brick} PAYS ${award}`,

    diamondSpinSecondScreenHelp: (trigger: string) =>
        `3X ${trigger} AWARD 3 SPINS <br/>
    4X ${trigger} AWARD 4 SPINS <br/>
    5X ${trigger} AWARD 5 SPINS <br/>`,
    totalwinHoldAndSpin: "GANADOS",
    totalleftHoldAndSpin: "SPINS RESTANTES",

    playedBigFG: "JUGADOS",
    leftbigfg: "SPINS RESTANTES",
    freeroundTitle: "FREE ROUNDS",
    freeroundmessage: (freeRoundsStat: FreeRoundsStats, betFormated: string) => `AUN TIENES ${freeRoundsStat.FreeRoundsNumber - freeRoundsStat.PlayedFreeRoundsNumber} SPINS GRATIS EN APUESTA ${betFormated}`,
    freerRoundCounterText: (freeRoundsRemaining: number) => `SPINS GRATUITOS RESTANTES: ${freeRoundsRemaining}`,

    HoldAndSpinHelp: (trigger: string) =>
        `DURANTE EL JUEGO BASE 6 O MAS ${trigger}SCATTERS INICIAN EL BONO.<br/>
    LOS SCATTERS ${trigger} DE JUEGO BASE SE QUEDAN EN SU POSICION PARA EL BONO STICKY SPIN.<br/>
    INICIALMENTE SON OTORGADOS 3 SPINS .<br/>
    CADA UNO O MAS ${trigger}SCATTERS QUE APARECEN DURANTE EL SPIN DE BONO TAMBIEN SE QUEDAN PEGADOS Y REGRESAN LOS SPINS RESTANTES A 3. <br/>
    STICKY SPIN BONO SE ACABA CUANDO NO HAY MAS SPINS O CUANDO SE GANA EL DIAMOND JACKPOT JUNTANDO 15 SCATTERS ${trigger}.<br/>
    TODOS LOS PREMIOS MOSTRADOS EN  ${trigger} SERAN  GANADOS AL FINAL DE BONO.<br/>
    LOS PREMIOS DE TABLA DE PAGOS NO APLICAN DURANTE EL BONO STICKY SPIN.<br/>
    `,


    BigFG: (textSpanish: string, textEnglish) =>
        `${textSpanish}`,



    HelpInfoTriggerBigFG: `CON 3 O MAS SIMBOLOS BONUS\n
    GANAS JUEGOS GRATIS.`,
    //HelpInfoTriggerBigFG2:"GANAS JUEGOS GRATIS",

    HelpInfoPlusBigFG: (triggerValue: number) => `DURANTE LOS JUEGOS GRATIS \n
    CADA SIMBOLO BONUS GRANDE\n
    TE AGREGA ${triggerValue} JUEGO(S) GRATIS ADICIONAL(ES)
    .`,

    HelpInfoPlusFG: (triggerValue: number, maxAdditionalFreegames: number) => `DURANTE LOS JUEGOS GRATIS \n
    CADA SIMBOLO BONUS\n
    TE AGREGA ${triggerValue} JUEGOS GRATIS ADICIONALES,
    MAXIMO ${maxAdditionalFreegames} FREE GAMES ADICIONALES.`,

    HelpInfoFGBonusIntoBonus: (bonusNameTrigger: string, countSymbolTrigger: number, symbolImgTrigger: string) => `DURANTE  JUEGOS GRATIS  \n 
    ${countSymbolTrigger} X ${symbolImgTrigger} O MAS   \n
    ACTIVAN  ${bonusNameTrigger}.`,
    //HelpInfoPlusBigFG2:"CADA SIMBOLO BONUS GRANDE",
    //HelpInfoPlusBigFG3:"TE AGREGA 3 JUEGOS GRATIS ADICIONALES",



    BigHoldAndSpinHelpWin:
        `DURANTE LOS JUEGOS GRATIS\n
    EL SIMBOLO GRANDE INICIA EL BONO BIG STICKY SPIN.\n
    INICIALMENTE SON OTORGADOS 3 SPINS.`,
    BigHoldAndSpinHelpWin2:
        `CADA UNO O MAS SCATTERS QUE APARECEN DURANTE EL BONO STICKY SPIN \n 
    SE QUEDAN PEGADOS Y REGRESAN LOS SPINS RESTANTES A 3.\n
    EL BONO SE ACABA CUANDO NO HAY\n
    MAS SPINS O CUANDO SE GANA EL DIAMOND JACKPOT JUNTANDO 7 SCATTERS.\n`,
    BigHoldAndSpinHelpWin3:
        `TODOS LOS PREMIOS MOSTRADOS\n 
    SERAN  GANADOS AL FINAL DE BONO.\n
    LOS PREMIOS DE TABLA DE PAGOS\n
    NO APLICAN DURANTE EL BONO STICKY SPIN.\n`,

    HoldAndSpinHelpWin: (triggerBonus: number) =>
        `DURANTE EL JUEGO BASE ${triggerBonus} O MAS SCATTERS INICIAN EL BONO.\n
    EN EL JUEGO BASE SE QUEDAN PEGADOS EN SU POSICION PARA EL BONO STICKY SPIN.\n
    INICIALMENTE SON OTORGADOS 3 SPINS.`,
    HoldAndSpinHelpWin2: (fullAwardCount: number) =>
        `CADA UNO O MAS SCATTERS QUE APARECEN DURANTE EL BONO STICKY SPIN \n 
    SE QUEDAN PEGADOS Y REGRESAN LOS SPINS RESTANTES A 3.\n
    EL BONO SE ACABA CUANDO NO HAY\n
    MAS SPINS O CUANDO SE GANA EL JACKPOT JUNTANDO ${fullAwardCount} SCATTERS.\n`,

    WildBulkDescription: "SE EXPANDE SOBRE TODOS\n LOS SIMBOLOS VECINOS.",
    WildBulkDescriptionPixi: "SE EXPANDE A LOS SIMBOLOS VECINOS.",
    WildReelDescription: "SE EXPANDE SOBRE TODO EL RIEL.",
    WildTriggerBonus: "SI HAY ALGUNO DE ESTOS SIMBOLOS\n EN PANTALLA NO LOS SUSTITUYE.",
    WildReplaceDescription: "SI GANO UN BONO SE ACTIVARA\n DESPUES DE QUE EL WILD\n SUSTITUYE LOS SIMBOLOS.",

    turboDescription: `
    PARA EL JUEGO EXTREMAMENTE RAPIDO Y DIVERTIDO PUEDE PRENDER EL TURBO JUEGO  \n
    EL JUEGO BASE VA A SER MUY RAPIDO HASTA UNA GANANCIA GRANDE O CUALQUIER BONO \n
    MANTEN PRESIONADO POR 3 SEGUNDOS PARA ACTIVAR EL TURBO JUEGO \n
    HASTA QUE EN EL BOTON JUGAR APARECE TURBO \n
    SOLTANDO EL BOTON JUGAR VA APAGAR EL MODO TURBO DE INMEDIATO`,

    TitleTurboPlay: 'TURBO JUEGO',

    TurboTitle: (TitleSpanish: string, TitleEnglish) =>
        `${TitleSpanish}`,

    selectGame: `SELECCIONA JUEGO`,
    selectDenom: `SELECCIONA DENOMINACION`,
    settingsTitle: `CONFIGURACION DEL JUEGO`,
    buttonMenuAccept: "ACEPTAR",
    buttonMenuCancel: "CANCELAR",
    callAttendant: "LLAMAR\nASISTENTE",
    extendedSpinAndHoldInfoUnlock: "MAS PARA DESBLOQUEAR",
    extendendDiamondSpinRemaining: (spinLeft: number) => `SPINS RESTANTES: ${spinLeft}`,
    extendendLasSpinMessage: "ULTIMO GIRO",
    helpInfoExttendedSpinAndHold: (trigger: string, triggerCount: number, resetSpins: number, columns: number, rows: number, unlockRowsConfig: UnlockRowsConfig) => {



        let rowsIncrementing = [...unlockRowsConfig.Rows].sort((a, b) => a.Unlock - b.Unlock)
        let startText = rowsIncrementing.map((r, i) => ` CON ${rows - rowsIncrementing.length + i + 1} FILAS DESBLOQUEADAS CUANDO SE ACTIVA CON ${unlockRowsConfig.BaseCount + r.Unlock}  ${trigger}`).join(", ");

        return `
        ${triggerCount} O MAS SIMBOLOS ${trigger} ACTIVAN EL BONO EXTENDED STICKY SPIN.\n
        EL BONO COMIENZA CON ${rows - unlockRowsConfig.Rows.length} FILAS DESBLOQUEADAS , CUANDO SE ACTIVA CON ${triggerCount}, ${startText}.\n

        ${resetSpins} GIROS SON GANADOS.\n
        TODOS ${trigger} SIMBOLOS ESTAN BLOQUEADOS EN SU LUGAR DURANTE LA DURACION DEL BONO Y LOS SIMBOLOS RESTANTES GIRAN INDEPENDIENTEMENTE .\n
        SI  UN NUEVO  ${trigger} APARECE , EL SIMBOLO SE BLOQUEARA EN SU LUGAR DURANTE EL BONO.\n
        EL NÚMERO DE GIROS RESTANTES SE REINICIA  A ${resetSpins} CON CADA NUEVO SYMBOLS DESBLOQUEADO ${trigger} Y  APARECERA UNA NUEVA FILA DESBLOQUEADA.\n
        RECOLECTANDO EL NUMERO INDICADO DE SIMBOLOS ${trigger} EN LAS FILAS DESBLOQUEADAS , SE DESBLOQUEARA UNA FILA ADICIONAL.\n        
        PARA GANAR EL DIAMOND POT SE NECESITA JUNTAR LOS ${rows * columns} ${trigger}        
        PUEDES ACELERAR EL CONTEO DE GANANCIAS EN EL BONO PRESIONANDO EL BOTON JUGAR `
    },

    skipMessageCommets: "Para saltar cometas Presiona Jugar",

    scatterBonusPaytableMessage: (scatterData: IPublicSimpleBonusTrigger) => `${scatterData.Count} O MAS SCATERS \n ACTIVARAN ${transformNameBonus(SpanishTranslation.language, scatterData.BonusName).toUpperCase()}`,
    wildPaytableMessage: (imgBonusTrigger?: string) => `WILD EN REELS 1, 3, 5 \n SUSTITUYE TODOS \n ${imgBonusTrigger} AUN GANAN`,
    scatterPaysAnywhereMessage: `PAGA EN CUALQUIER PARTE`,
    wildBulkPaytableMessage: (reelIndexData, imgBonusTrigger?: string) => `WILD APARECE EN LOS REELES ${reelIndexData} \n SE EXPANDE A TODOS LOS SIMBOLOS VECINOS \n  SUSTITUYE A TODOS LOS SIMBOLOS EXCEPTO A LOS SCATTERS  <br>${imgBonusTrigger} `,
    wildReelPaytableMessage: (imgBonusTrigger) => `WILD APARECE EN TODOS LOS REELES Y SE EXPANDE A TODOS LOS SIMBOLOS EN EL MISMO REEL Y SUSTITUYE A TODOS LOS SIMBOLOS EXCEPTO A LOS SCATERS <br>${imgBonusTrigger}`,
    StartingFreegamesHelp: (symbolsCount: number, startingFreegames: number, bonusWildSymbolContainer: string) => `SI GANAS ${bonusWildSymbolContainer} X ${symbolsCount} , JUGARAS  ${startingFreegames} GIROS GRATIS.`,

    doubleUpTitle: `DOBLE O NADA `,
    doubleUpHistoryTitle: `HISTORIAL`,
    doubleUpLastCardTitle: `ULTIMA CARTA`,
    doubleUpRedCardTxt: `ROJO`,
    doubleUpBlackCardTxt: `NEGRO`,
    doubleUpCollectBtnTxt: `COBRAR`,
    doubleUpRHalfBetBtnTxt: `COBRAR MITAD`,
    doubleUpWinSign: `YOU WIN`,
    doubleUpLoseSign: `BETTER LUCK NEXT TIME`,
    doubleUpSelectedSign: `SELECCIONADO!`,
    doubleUpGainTxt: `ULTIMO GANADO`,
    doubleUpCollectHalfTxt: `COBRAR MITAD`,
    doubleUpCollectAllTxt: `COBRAR TODO`,
    doubleUpBetLimitSignTxt: `LIMITE DE GANANCIA EXCEDIDO! `,
    doubleUpWinLimitSignTxt: (winLimit: string) => `LIMITE DE GANANCIA ${winLimit}`,
    doubleUpBetAndWinTxt: (bet, win) => `ELIGE UN COLOR Y APUESTAS ${bet} GANAS ${win}`,
    doubleUpGameLimitTxt: (maxPicks) => `MAXIMO ${maxPicks} INTENTOS`,
    wildStackDescription: (imgBonusTrigger: string, reels: number[]) => `${imgBonusTrigger} EN RIELES  ${reels.join(", ")} \n SUSTITUYE TODOS LOS SIMBOLOS.`,
    grandJackpotMultiBonusDescription: (sraImg: string) => `PARA GANAR EL GRAND JACKPOT NECESITAS GANAR 15 0 30 DE ${sraImg} DEPENDIENDO DE QUE VARIANTE DE BONO O LA COMBINACION DE BONOS GANASTE`,
    doubleUpDescription: (winLimit: string) => `ADIVINA EL COLOR DE LA CARTA QUE APARECE EN MEDIO Y SI LO LOGRAS PODRIAS GANAR EL DOBLE DE TU GANANCIA, SI NO, LO PIERDES TODO! SI EN LA SIGUIENTE RONDA TU GANANCIA EXCEDE ${winLimit} ENTONCES SE COBRARA AUTOMATICAMENTE LA GANANCIA PREVIA. PUEDES COBRAR LA MITAD DE TU APUESTA SI SELECCIONAS EL BOTON COBRAR MITAD O COBRAR TODA TU GANANCIA SI SELECCIONAS COBRAR TODO. SI COBRAS TODO O PIERDES EL JUEGO TERMINA`,

    spinandHoldInfoHelpFullAward: `PAGA TODOS LOS PREMIOS QUE APARECEN EN PANTALLA`,
    WildStackFeature: `NO SUSTITUYE`,
    fillingPotTitle: `FILLING POT`,
    fillingPotDescription: `ES UNA ANIMACION ACUMULATIVA. CUANTO MAS LLENO O COMPLETO ESTE, MAS CERCA ESTARA DE GANAR UN BONO. CADA APUESTA MANTIENE SU PROPIO NIVEL DE ANIMACION. JUGAR PUEDE INCREMENTAR EL NIVEL DE ANIMACION DE LA APUESTA REALIZADA. GANAR EL BONO RESTABLECE LA ANIMACION AL INICIO DE LA APUESTA REALIZADA.`,
    DialogIntroPixiBonus: (textSpanish, textEnglish) => { return textSpanish },
    DialogFinalPixiBonus: (textSpanish, textEnglish) => { return textSpanish },

    jackpotSharedDescription: `EL MONTO DENTRO EL SHARED SE DISTRIBUYE PROPORCIONALMENTE ENTRE LOS JUGADORES JUGANDO EN EL MOMENTO QUE SE GANA EL JACKPOT PRINCIPAL  EN BASE DE LA ULTIMA APUESTA.`,
    bonusMultiplierDescription: `CUANDO APARECE BONUS MULTIPLIER EN PANTALLA EL PROXIMO BONUS SE MULTIPLICARA POR X2 O X3 JUGANDO EN LA MISMA APUESTA. LOS UNICOS JACKPOTS QUE MULTIPLICA SON MINOR Y MINI`,
    bonusSpinsRemainingAndTotal: (from: number, to: number) => `Spin ${from} of ${to}`,
    portalBonusDescription: `EN EL PORTAL BONUS, APARECEN FICHAS ESPECIALES TIPO “PORTAL”.
    CUANDO UNA FICHA PORTAL CAE EN LOS REELS : ACTIVA EL PORTAL EN SU POSICIÓN.
    EL PORTAL ABSORBE TODOS LOS SÍMBOLOS BLOQUEADOS QUE ESTÉN EN LOS DEMÁS REELS Y LIBERA LOS MISMO PARA NUEVOS PREMIOS.
    SE SUMAN TODOS LOS VALORES DE LOS SÍMBOLOS ABSORBIDOS AL PORTAL.
    EL PORTAL QUEDA COMO UN SÍMBOLO ACUMULADO, CON EL VALOR TOTAL COMBINADO.`,
    FillingGrandJackpotMultiBonusDescription: (sraImg: string) => `PARA GANAR EL PREMIO GRAND JACKPOT  \n  
    DEBES CONSEGUIR y COLLECTAR 6 SYMBOLOS ${sraImg} GRAND  \n  
    ES POSIBLE GANAR UNO O MAS PREMIOS GRAND JACKPOT EN UN BONO .`,
    buyBonusDisabledMessage: `SI EL BOTON DE COMPRA BONO SE ENCUENTRA DE COLOR GRIS, COMPRA BONO NO ESTA DISPONIBLE PARA LA APUESTA SELECCIONADA`,
    fillingJackpotMultiBonusDescription: (jackpots: HTMLSpanElement[]) =>
        `HAY ${jackpots.length} NIVELES JACKPOT: ${jackpots.filter(Boolean).map(jackpot => jackpot.outerHTML).join(", ")}.

    DURANTE EL BONUS, PUEDEN CAER SÍMBOLOS DE SRA JACKPOT EN LOS REELS.
    CADA SRA SE CONVIERTE EN UN COMETA QUE VUELA HACIA SU JACKPOT Y LLENA SU MEDIDOR.

    CADA JACKPOT TIENE DIFERENTES CONTENEDORES A LLENAR, CUANDO LLENAS TODOS: ¡GANAS ESE JACKPOT! 
    EL REELS DONDE CAYÓ EL SYMBOL SRA SE LIBERA Y PUEDE SEGUIR DANDO MÁS JACKPOTS O PREMIOS.

    ¡PUEDES GANAR VARIOS JACKPOTS EN UN SOLO BONUS! `,
    symbolPayFeatureSRA: (count, bonusName) => `${count} O MAS \n ACTIVARAN EL BONO`,

}

export const RomanianTranslation: Translation =
{
    locality: "ro-RON",
    languageEnglish: "Romanian",
    language: "Romanian",
    localityShort: "ro",
    enableBuyBonus: "Activați achiziția bonus?",
    betAndCreditsBuybonus: (buyBonusValueString: string, buyBonusCreditsString: string) => "PRET BONUS : " + buyBonusValueString,

    buyStickyBonus: "PARIUL JOC DE BAZĂ : ",
    buyStickyBonusConfirmMessage: "VA ROG CONFIRMATI CUMPARAREA",
    buyStickyBonusConfirmMessage2: "CONFIRMAREA CUMPĂRĂRII ȚI ESTE ACORDAT PENTRU CÂȘTIGĂ UN JOC BONUS , CU UNUL DINTRE BONUSURI DISPONIBILE SAU ORICE COMBINAȚIE A ELE",
    price: "Preț: ",

    balance: "CREDITE",
    buyBonusTitle: "COMPRARE BONUS",
    buyBonusButton: "COMPRARE<br />BONUS",
    jackpotBonusDescription: "IN JACKPOT BONUS YOU HAVE A CHANCE TO WIN AVAILABLE JACKPOTS YOU CAN WIN MORE JACKPOTS BEING THE SAME OR DIFFERENT BUT YOU ARE GUARANTEED TO WIN MINIMUM 1 OF THEM",
    doubleBonusDescription: "DOUBLE BONUS EXTENDS REELS TO 6 SYMBOLS PER REEL SO YOUR CHANCE TO WIN IS GREATER AND YOUR TOTAL WIN HIGHER",
    multiplierBonusDescription: "MULTIPLIER BONUS MULTIPLIES ALL WINS EXCEPT GRAND JP AND MAJOR JP BY 2, 3 OR 4. WHICH IS DETERMINED WHEN WINNING THE BONUS",
    multibonusCombinedDescription: "YOU CAN WIN ANY COMBINATION OF TWO BONUSES TOGETHER WITH ALL THE BENEFITS FROM BOTH OF THEM",
    rowHelpDescription: "YOU CAN ALSO WIN ALL 3 BONUSES TOGETHER WITH ALL THE BENEFITS FROM ALL 3 OF THEM THE WINS ARE EXPECTACULAR",
    multibonusTitle: "MULTIBONUS",
    multibonusDescription: "4 OR MORE OF ANY OF THESE SYMBOLS WINS THE BONUS. \n THE BONUS CAN ALSO BE WON IN FREE GAMES",
    bet: "Pariu",
    totalBet: "Pariul total",
    maxbet: "JUCAT<br/>MAXIM",
    doubleUp: "DUBLA<br/>CÂȘTIGA",
    auto: "JOARE<br/>AUTO",
    doubleup: "DUBLA",
    backtogametxt: "BACK TO GAME",


    collect: "PLATĂ",
    spin: "JUCA",
    turbo: "TURBO",
    menu: "MAI MULTE<br>JOCURI",
    message_pressspin: "Apăsați JUCA pentru a începe jocul",
    message_insertcredit: "Introduceți creditul",
    message_goodluck: "Mult noroc!",
    //lineplay:"PLAY",
    //line:"LINES",
    playingOnLines: (lines: number) => `JUCA ${lines} LINII`,
    playingDenomOnLines: (denomFormatted: string, lines: number) => `JUCA ${lines} LINII, DENUMIREA ${denomFormatted}`,
    selectedLines: (lines: number) => `${lines}<span style="white-space:nowrap; transform:rotate(90deg); display:block">LINES</span>`,
    denom: "DENUMIREA",
    denomOneCredit: "1 CRITERAT",
    tbet: "JUCA",
    login: "introduceți pinul",
    tline: "PARIU/LINIE",
    stop: "OPRI",
    message_bonustriggered: "Jocul primă declanșat",
    bonusstar: "Începe jocul primă",
    mailfuncion: "Eșecul anulează toate plățile și jocurile",
    amusement: "Distracție doar fără valoare în numerar",
    win: "VICTORIE",
    lastwin: "ULTIMUL CÂŞTIG",
    paytable: "TABEL DE PLATI",
    paylines: "LINII DE PLATĂ",
    freeGameTitle: "PRIMĂ DE JOC GRATUIT",
    optionsbtntxt: "CONFIG",

    DiamondSpinIntro: (spinlogo: string) => `FELICITĂRI <br />
    AI CASTIGAT <br />
    ${spinlogo} PRIMĂ <br />
    APĂSAȚI START PENTRU A ÎNCEPE.`,

    linepay: (linenumber: string, linewinCredits: string) => `Linia ${linenumber} plătește ${linewinCredits} credite`,

    //free game help page 
    freeGameHelpDescription: (triggerToEnterBonus: string, trigger: string, maxFreeGames: string, wincredits: string, bonusScreen2: string, bonusScreen3: string) =>
        `${triggerToEnterBonus} SAU MAI MULT ${trigger} CÂȘTIGĂ BONUS DE JOC GRATUIT. CÂŞTIGĂ PÂNĂ PÂNĂ ${maxFreeGames} JOCURI GRATUITE.<br />${bonusScreen2}`,

    // diamond pot help page
    diamondPotHelpDescription: (trigger: string, pick: string, jp1: string, jp2: string, jp3: string, jp4: string, pot: string, numberOfPicks: string, lastPageNumberOfPicks: string, maxPicks: string) =>
        ` 3 ${trigger} PRIMĂ POT DIAMOND TRIGGER <br />
        IN PRIMĂ DIAMOND POT TREBUIE DESCHIS ${numberOfPicks} ${pick}, DE LA ${maxPicks} DISPONIBIL.<br />
        SUB SIMBOLULE ${pick} AI PREMII ȘI BIJUTERĂV.
        GĂSIREA MĂRÂN O BIJUTERĂ ${jp1}, ${jp2}, ${jp3}, ${jp4}, ORICE CULOARE ȘI VOI PUNEȚI LA NIVELUL URMĂTOR.<br />
        AI 3 NIVELURI ÎN CARE POȚI CÂȘTIGA RUBIN, SAFIR ȘI SMERALDA.
        DACĂ GĂSEȘTI 4 DIAMANTE DE ACEEAȘI CULOARE PUTEȚI CÂȘTIGA MAI MULT DE UN PRIMĂ.<br />
        DACĂ GĂSEȘTI 3 DIAMANTE CU ACEASTA CULOARE ${jp4} DACĂ GĂSEȘTI 3 DIAMANTE CU ACEASTA CULOARE.<br />
        DE UNDE <span class="pickBonus-lastPageNumberOfPicks">&nbsp;${lastPageNumberOfPicks}</span> ${pick} ALEGEȚI DOAR UNUL, TREBUIE SĂ GĂSIȚI AL PATRA DIAMANT ALB.<br />
        ȘI DACĂ GĂSEȘTI AI CÂȘTIGAT ${pot}.<br />
        DACĂ RATEȚI JOCUL PRIMĂ S-A SCHIȘIT.
        `,

    // dragon pot help page
    dragonPotHelpDescription: (trigger: string, pick: string, jp1: string, jp2: string, jp3: string, jp4: string, pot: string, numberOfPicks: string, lastPageNumberOfPicks: string, maxPicks: string) =>
        ` 3 ${trigger} DECLANŠATORUL  DRAGON  LINK 
    ÎN DRAGON LINK TREBUIE SĂ DESCHIS ${numberOfPicks} ${pick}, DE LA ${maxPicks} DISPONIBIL.<br />
    SUB SIMBOLULE ${pick} AI PREMII ȘI DRAGONI.<br />
    GĂSIREA MĂȚIN UN DRAGON: ${jp1}, ${jp2}, ${jp3}, ${jp4}, DE ORICE CULOARE ȘI VEȚI PROCEDE LA NIVELUL URMĂTOR.<br />
    AI 3 NIVELURI ÎN CARE POȚI CÂȘTIGA MINI PRIMĂ, MINOR PRIMĂ, GRAND JACKPOT ȘI DRAGON JACKPOT.
    DACĂ GĂSEȘTI 4 DRAGONI DE ACEEAȘI CULOARE PUTEȚI CÂȘTIGA MAI MULT DE UN PRIMĂ.<br/>
    DACĂ GĂSEȘTI 3 DRAGONI CU ACEASTA CULOARE ${jp4} DACĂ GĂSEȘTI 3 DRAGONI CU ACEASTA CULOARE ÎN PRIMELE TREI FOARTE CÂȘTIGI SUPER NIVEL.<br/>
    DE UNDE <span class="pickBonus-lastPageNumberOfPicks">&nbsp;${lastPageNumberOfPicks}</span> ${pick} ALEGEȚI NUMAI UNUL, TREBUIE SĂ GĂSIȚI AL PATRA DAGON ALB.<br />
    ȘI DACĂ GĂSȚI CĂ AȚI CÂȘTIGAT ${pot}.<br />
    DACĂ RATEȚI JOCUL PRIMĂ S-A SCHIȘIT.
    `,


    pickbonus: (symbol: string) =>
        `ALEGEȚI 5 ${symbol} ÎN CĂUTAREA COMORII`,

    winbonus: (win: string) =>
        `FELICITĂRI  <br /> AI CASTIGAT <br /> ${win}  <br />Atingeți ecranul pentru a continua`,

    rulediamon: (diamon: string) =>
        `3 ${diamon} SAU MAI MULT ORIUNDE DESCHIDE DIAMANTUL<br />&emsp;&emsp;&ensp; POT PRIMĂ ȘI PLATĂ PÂNĂ LA <span class="upto"> 1250 CREDITS</span><br />
        4 ${diamon} ORIUNDE PÂNĂ <span class="upto"> 12500 CREDITE</span><br />
        5 ${diamon} ORIUNDE PÂNĂ<span class="upto"> 50000 CREDITE</span><br />`,

    introfree: () => `<span class="header" >FELICITĂRI </span> <br />AI CASTIGAT<br />FREEGAME<br />PRIMĂ<br />Apăsați START pentru a intra în bonus`,

    commonWildTitle: "WILD",
    commonwild: (wildSymbolImage: string, wildScreen1: string) =>
        `${wildSymbolImage} ÎNLOCUIȚI TOATE SIMBOLULE  <br />
        ${wildScreen1}
        `,


    wildReelTitle: "MULINETĂ DE EXPANSIUNE WILD",
    wildReelDescription: (wildSymbolImage: string, freegameSymbolImage: string, pickBonusSymbolImage: string, wildScreen: string, wildScreen2: string) =>
        `${wildSymbolImage} SE EXPANDEAZĂ PE ÎNTREAGĂ TOBINA DE SIMBOLURI. <br />
        DACA EXISTA  ${freegameSymbolImage} SAU ${pickBonusSymbolImage} DECLANŠATOR PE ECRAN. <br />
        THE PRIMĂ IS ACTIVATED AFTER THE WILD REPLACES THE SYMBOLS.<br />
        ${wildScreen}`,

    wildBulkTitle: "EXPANDEREA VRACULUI WILD",
    wildBulkDescription: (featureTrigger: string, pickImage: string, diamon: string, wildScreen: string, wildScree2: string) =>
        ` ${featureTrigger} SE EXTINDE LA TOATE SIMBOLULE ADJACENTE. <br />
        DACA EXISTA  ${pickImage} SAU ${diamon} DECLANŠATOR PE ECRAN. <br />
        THE PRIMĂ IS ACTIVATED AFTER THE WILD REPLACES THE SYMBOLS.<br />
         ${wildScreen}`,
    //Wild with Scatter
    wildScatter: `ÎNLOCUIȚI TOATE SIMBOLULE\nCU EXCEPȚIA SCATTER`,

    progressivePickBonus: (ruby: string, emerald: string, sapphire: string, diamond: string, pots: string) =>
        `
        MĂRȘTEȘTE-ȚI PARIUL ȘI ȘANSELE DE CÂȘTIGĂ ${pots} ${sapphire} ${emerald} ${ruby} ${diamond} VA FI MULT MAI MULTE !!!!! 
        `,


    rulediamons: (ruby: string, emerald: string, sapphire: string, diamond: string, pot: string) =>
        `4 ${ruby} CÂȘTIGĂ RUBY  <br />
        4 ${emerald} CÂȘTIGĂ SMERALDA <br />
        4 ${sapphire} CÂȘTIGĂ SAFIR<br />
        4 ${diamond} VICTORIE ${pot}<br />`,

    played: "JUCAT",
    left: "STÂNGA",


    bonusinstru: (maxFreeGame: string) =>
        `CÂȘTIGĂ PÂNĂ LA ${maxFreeGame} JOCURI GRATUITE <br />`,




    // free game into message
    freegameCongratulations: "FELICITĂRI",
    freeGameYouHaveWon: "AI CÂȘTIGAT",
    freegameFreegame: "JOC GRATIS",
    freegameBonus: "PRIMĂ",
    freegamePressStart: "Apăsați START pentru a intra în bonus",
    freegameStart: "START",
    freegameExit: "IEȘIRE",
    freeGamePickInstruction: "ALEGEȚI SIMBOLUL PENTRU A DEZVĂLUI NUMĂRUL DE JOCURI GRATUITE",

    //free game pick info message
    freeGameGreat: "GROZAV",
    freeGameYouHavePicked: "AI ALESE",
    freeGameFreeGames: "JOCURI GRATUITE",
    freeGamePressStartToBegin: "Apăsați START pentru a începe ",

    //free game final message
    freeGameFinished: "JOCURI GRATUITE TERMINATE",
    //endfree2:"You have won",
    freeGameCredits: "CREDITE",
    freeGamePressExit: " APĂSAȚI EXIT PENTRU A REVENI LA JOC",


    welcome: "BINE ATI VENIT",
    footer: "ATINGEȚI ECRANUL PENTRU A PORNE",
    level1: "FELICITĂRI CĂ AȚI ATINGUT<br /> PRIMUL NIVEL",
    level2: "FELICITĂRI CĂ AȚI ATINGUT <br />AL DOILEA NIVEL",
    level3: "FELICITĂRI CĂ AȚI ATINGUT<br /> AL TREILEA NIVEL",
    level4:
        `FELICITĂRI .<br />
    Găsește ULTIMUL DIAMANT și CÂȘTIGĂ .<br />
    ACUM ESTE ȘANSA TA.<br />
    NOROC <br />ATINGEȚI ECRANUL PENTRU A PORNE`,

    wildreel: "SE EXPANDEAZĂ PENTRU SIMBOLULE DE BOMBĂ ȘI ÎNLOCUIȚI TOATE SIMBOLULE, CU EXCEPȚIA DIAMANTELOR ȘI A BONUS-URILOR",
    wildBulk: "SE EXPANDEȘTE PENTRU TOATE SIMBOLULE ȘI ÎNLOCUIȚI TOATE SIMBOLULE, CU EXCEPȚIA DIAMANTELOR ȘI BONUS-URILOR",
    //bonusinstru:"WIN UP TO 15 FREE GAMES <br />",
    levebonus1: "ESTI LA PRIMUL NIVEL. <br />PENTRU A AVANS DEZVLEVĂ MĂRÂN O BIJUTERĂ",
    levebonus2: "ESTI LA NIVELUL AL DOILEA. <br />PENTRU A AVANS DEZVLEVĂ MĂRÂN O BIJUTERĂ",
    levebonus3: "ESTI LA NIVELUL AL TREILEA. <br />NOROC.",
    levebonus4: "FELICITĂRI AI ATINGS LA NIVELUL DIAMANT",
    pickleft: (pick: number) => `ALEGERILE LASAT: ${pick}`,
    diamondSpinRemaining: (spinLeft: number) => `ROTIRI RĂMĂSE: ${spinLeft}`,
    titlefreegame: "BONUS DE JOC GRATUIT",
    totalwin: "CÂŞTIG TOTAL",
    won: "CASTIGAT",
    wildcommon: `ÎNLOCUIȚI TOATE SIMBOLULE`,
    extrafreegame: "CÂȘTIGĂ UN JOC GRATUIT ÎN TIMPUL JOCULUI GRATUIT BONUS ",
    extrafreegame2: "ALEGEȚI SIMBOLUL PENTRU A DEZVĂLUI NUMĂRUL DE JOCURI GRATUITE ",
    notcredit: "NU SUFICIENT CREDIT",
    goodluck: "NOROC",
    volumeControlHeader: `SOUND LEVEL`,
    speedControlHeader: `GAME SPEED`,
    minimumbetText: () => `<br/>YOU NEED TO BET AT LEAST ${service.moneyFormatter.FormatCurrency(250)} TO WIN ${JackpotProperties[Settings.JackpotDisplayType]?.jp4?.name} JACKPOT`,

    //progressivePickBonus: "INCREASE YOUR BET AND THE CHANCES OF WINNING POT WILL BE MUCH HIGHER !!!!!",


    diamondspinhelp: (trigger: string, logo: string, MachineImg: string, gold: string, silver: string, bronze: string, graphite: string) =>
        `TREI SAU MAI MULTE ${trigger} VA DECLANŠATOR ${logo}<br/>
    UN NUMAR DE ${trigger} PE ECRAN VA DETERMINA NUMĂRUL DE ROTIRI GRATUITE. <br/>
    DACĂ COLECTEȚI TREI ACEIAȘI ${gold}${silver}${bronze}${graphite} CÂȘTIGI UNUL DINTRE JACKPO-URI.
    `,

    /* `WITH  3  ${trigger} IT WILL TRIGGER   ${logo}<br/>
    IN ${logo}  THERE WILL BE  ${MachineImg} ONLY YOU HAVE A ONE SPIN .<br/>
    IF WHEN IT REEL STOP YOU HAVE 3  ${gold}${silver}${bronze}${graphite} EQUAL METAL YOU WILL BE THE JACKPOT WINNER OF THE METAL  .<br/>
   
    <div style=" box-sizing: border-box; background-color: rgb(0,0,0,0.5); border-radius: 49px; margin: 0 auto 0 auto;width: 40%; height: 50%; ">
    <br/>
    IF YOU DONT WON 3 EQUAL SYMBOLS, EACH SYMBOLS PAYS:     
    <br/>${gold}= 100 X BET    ${silver}= 80 X BET <br/>
    ${bronze}= 20 X BET  ${graphite}= 5 X BET <br/></div>`,
    */

    diamondspinPayTable: (brick: string, award: string) =>
        `FIECARE DIN ${brick} PLATĂ ${award}`,

    diamondSpinSecondScreenHelp: (trigger: string) =>
        `3X ${trigger} PREMIUL TREI ROTURI <br/>
    4X ${trigger} PREMIUL PATRU ROTIRI <br/>
    5X ${trigger} PREMIUL CINCI ROTIRI <br/>`,

    totalwinHoldAndSpin: "CÂȘTIGE",
    totalleftHoldAndSpin: "ROTIRI RĂMĂSE",

    playedBigFG: "JUCAT",
    leftbigfg: "ROTIRI RĂMĂSE",
    freeroundTitle: "FREE ROUNDS",
    freeroundmessage: (freeRoundsStat: FreeRoundsStats, betFormated: string) => `${freeRoundsStat.FreeRoundsNumber - freeRoundsStat.PlayedFreeRoundsNumber} FREE SPIN(S) REMAINING IN BET ${betFormated}`,
    freerRoundCounterText: (freeRoundsRemaining: number) => `FREE SPINS REMAINING: ${freeRoundsRemaining}`,

    HoldAndSpinHelp: (trigger: string) =>
        `ÎN TIMPUL JOCULUI DE BAZĂ ȘASE SAU MAI MULT ${trigger} DECLANŠATOR THE BONUS. <br/>
    ${trigger} DIN JOCUL DE BAZĂ RĂMÂNE ÎN POZIȚIA SA PENTRU BONUS DE START STICKY SPIN.<br/>
    SUNT ACORDATE INIȚIAL TREI ROTURI.<br/>
    FIECARE UNU SAU MAI MULTI ${trigger} CARE APAR ÎN TIMPUL ROȚIUNII BONUS SE IMPOT ȘI ȘI RĂMĂSILE ÎNVĂRIRI SE REVIN LA TREI.<br/>
    STICKY SPIN BONUS ESTE TERMINAT CÂND NU ESTI FĂRĂ ROTARI SAU JACKPOTUL DIAMOND ESTE CÂȘTIGAT. <br/>
    TOATE PREMIILE PE ${trigger} SUNT ACORDATE LA SFÂRȘITUL BONUSULUI STICKY SPIN. <br/>
    PREMIILE PENTRU TABLA DE PLĂTI NU SE ACORDĂ ÎN TIMPUL STICKY SPIN BONUS.
    `,


    BigFG: (textSpanish: string, textEnglish) =>
        `${textEnglish}`,

    HelpInfoTriggerBigFG: `CU TREI SAU MAI MULTE SIMBOLURE BONUS \n 
    CÂȘTIGĂ JOCURI GRATUITE.`,
    //HelpInfoTriggerBigFG2:"WIN FREE GAMES",


    HelpInfoPlusBigFG: (triggerValue: number) => `ÎN TIMPUL JOCURILOR GRATUITE \n 
    FIECARE SIMBOL BONUS MARE \n
    TE ADAUGĂ ${triggerValue} JOCURI SUPLIMENTARE GRATUITE.`,

    HelpInfoPlusFG: (triggerValue: number, maxAdditionalFreegames: number) => `ÎN TIMPUL JOCURILOR GRATUITE \n 
    FIECARE SIMBOL BONUS \n
    TE ADAUGĂ ${triggerValue} JOCURI SUPLIMENTARE GRATUITE\n
    MAXIMUM ADITIONAL ${maxAdditionalFreegames} FREE GAMES.`,

    HelpInfoFGBonusIntoBonus: (bonusNameTrigger: string, countSymbolTrigger: number, symbolImgTrigger: string) => `ÎN TIMPUL JOCURILOR GRATUITE \n 
    ${countSymbolTrigger} X ${symbolImgTrigger} OR MORE  \n
    TRIGGER ${bonusNameTrigger}.`,
    //HelpInfoPlusBigFG2:"EVERY BIG BONUS SYMBOL",
    // HelpInfoPlusBigFG3:"ADDS YOU 3 ADDITIONAL FREE GAMES",


    BigHoldAndSpinHelpWin:
        `ÎN TIMPUL JOCURILOR GRATUITE\n
    SIMBOLUL SCATTER MARE DECLANȘEAZĂ.\n
    SUNT ACORDATE INIȚIAL TREI ROTURI.`,
    BigHoldAndSpinHelpWin2:
        `UNUL SAU MAI MULTE SCATTER CARE APAR ÎN TIMPUL ROTIRII BONUS \n
    DE ASEMENEA, SE BLOCHEAZĂ, IAR ROTIRI RĂMASE REVIN LA TREI.\n
    BONUSUL ESTE TERMINAT \n
    CÂND NU ESTI FĂRĂ SPINS SAU JACKPOTUL DE DIAMANTE ESTE CÂȘTIGAT.`,
    BigHoldAndSpinHelpWin3:
        `SE ACORDATE TOATE PREMIILE DE PE\n
    LA SFÂRȘITUL BONUSULUI STICKY SPIN.\n
    PREMIILE DE PLATĂ\n
    NU SUNT ACORDĂȚI ÎN TIMPUL STICKY SPIN BONUS.`,



    HoldAndSpinHelpWin: (triggerBonus: number) =>
        `ÎN TIMPUL JOCULUI DE BAZĂ ${triggerBonus} SAU MAI MULTE SCATTERS DECLANCĂ BONUSUL.\n
    ÎN JOCUL DE BAZĂ RĂMÂNE BLOCIT ÎN POZIȚIA SA PENTRU START STICKY SPIN BONUS.\n
    SUNT ACORDATE INIȚIAL TREI ROTURI..`,
    HoldAndSpinHelpWin2: (fullAwardCount: number) =>
        `FIECARE DINTRE DISPERSIUNI CARE APAR ÎN TIMPUL ROTIRII BONUS \n
    SUNT BLOCATE ȘI ROTARIILE RĂMĂSE REVEN LA TREI.\n
    BONUSUL ESTE TERMINAT \n
     CÂND NU ESTI FĂRĂ ROTIRE SAU CÂȘTIGĂ JACKPOT-UL ADUNAND ${fullAwardCount} SCATTERS`,

    WildBulkDescription: "SE EXPANDEAZĂ PENTRU TOATE SIMBOLULE DE VECIN.",
    WildBulkDescriptionPixi: "EXPANDS OVER ALL NEIGHBOUR SYMBOLS.",
    WildReelDescription: "SE EXPANDEAZĂ PE ÎNTREAGĂ TOBINA DE SIMBOLURI.",
    WildTriggerBonus: "DACĂ EXISTĂ ORICE DINTRE ACEST SIMBOLUL \n PE ECRAN NU LE ÎNLOCUIEȘTE.",
    WildReplaceDescription: "DACĂ CÂȘTIGI UN BONUS ȘI\nWILD ÎN ACEȘI JOC\nBONUSUL VA FI ACTIVAT\nDUPĂ CE WILD ÎNLOCUIEȘTE SIMBOLULE",

    turboDescription: `
    PENTRU UN JOC EXTREM DE RAPID ȘI EMOZANT PUTEȚI ACTIVA TURBO PE JOC \n
    JOCUL DE BAZĂ SE VA RUCLA FOARTE RAPID PÂNĂ CÂȘTIGĂ UN CÂȘTIG MAI MARE SAU UN BONUS \n
    PENTRU A-L PORNI APĂSAȚI BUTONUL DE PORNIRE TIMP DE MĂRÂN 3 SECUNDE ȘI APOI ȚINEȚI-L APĂSAT\n
    ELIBERAREA BUTONULUI DE START VA OPRI IMMEDIAT JOCUL TURBO`,

    TitleTurboPlay: 'TURBO JUCA',

    TurboTitle: (TitleSpanish: string, TitleEnglish) =>
        `${TitleEnglish}`,

    selectGame: `SELECTARE JOC`,
    selectDenom: `ALEGE DENUMIREA`,
    settingsTitle: `GAME CONFIGURATION`,
    buttonMenuAccept: "ACCEPTA",
    buttonMenuCancel: "ANULARE",
    callAttendant: "INSOTITOR DE APEL",
    extendedSpinAndHoldInfoUnlock: "MAI MULT DE DEBLOCAT",
    extendendDiamondSpinRemaining: (spinLeft: number) => `ROTIRI RĂMĂSE: ${spinLeft}`,
    extendendLasSpinMessage: "ULTIMA ROTIRE",
    helpInfoExttendedSpinAndHold: (trigger: string, triggerCount: number, resetSpins: number, columns: number, rows: number, unlockRowsConfig: UnlockRowsConfig) => {



        let rowsIncrementing = [...unlockRowsConfig.Rows].sort((a, b) => a.Unlock - b.Unlock)
        let startText = rowsIncrementing.map((r, i) => ` CU ${rows - rowsIncrementing.length + i + 1} RÂNDURI DEBLOCATE CÂND DECLICATE CU ${unlockRowsConfig.BaseCount + r.Unlock}  ${trigger} `).join(", ");

        return `
        ${triggerCount} SAU MAI MAI RĂSFIATĂ  ${trigger} DECLANȘEAZĂ SPIN ȘI ȚINEȚI ȚINE.\n
        CARACTERISTICA ÎNCEPE CU ${rows - unlockRowsConfig.Rows.length} RÂNDURI DEBLOCATE CÂND DECLICATE CU ${triggerCount}, ${startText}.

        ${resetSpins} SPIN-URILE SUNT ACORDATE.\n
        TOATE SIMBOLULE ${trigger} SE BLOCEAZĂ ÎN LOCAL PENTRU DURATA CARACTERISTICII, ȘI SIMBOLELE RĂMĂSE SE ROTESC INDEPENDENT.\n
        DACĂ ESTE NOU ${trigger} AARE, SIMBOLUL SE BLOCEAZĂ PE LOC PENTRU DURATA FUNCTĂRII.\n
        NUMĂRUL DE ROTARI RĂMĂSE SE RESETĂ LA${resetSpins} CU FIECARE NOUL BLOCAT ${trigger} CARE APARE PE UN RÂND DEBLOCAT.\n
        ADUNA TOTUL NUMĂRULUI INDICAT DE SUPLIMENTARE ${trigger} ÎN RÂNDURI DEBLOCATE DEBLOCEAZĂ ACEL RÂND SUPLIMENTAR.\n
        PENTRU A CÂȘTIGA VASOA DE DIAMANTE TREBUIE SĂ CULEGI TOATE ${rows * columns} ${trigger}.        
        PUTEȚI GELERI NUMĂRUL DE CÂȘTIGURI ÎN BONUS APĂSÂND START`
    },
    skipMessageCommets: "Treci la următoarea cometă Apăsați Start",

    scatterBonusPaytableMessage: (scatterData: IPublicSimpleBonusTrigger) => `${scatterData.Count} SAU MAI MULTE ÎMPRĂȘTIE \n VA DECLANȘA ${transformNameBonus(RomanianTranslation.language, scatterData.BonusName).toUpperCase()} `,
    wildPaytableMessage: (imgBonusTrigger?: string) => `WILD PE RULINE 1, 3, 5 \n ÎNLOCUIȚI TOȚI \n ${imgBonusTrigger} ÎNCĂ PREMIAT `,
    scatterPaysAnywhereMessage: `PAYS ANYWHERE`,
    wildBulkPaytableMessage: (reelIndexData, imgBonusTrigger?: string) => `WILD APARE PE BOMBELE ${reelIndexData} \n ȘI SE EXPANDE LA TOȚI VECINII \n SIMBOLULE ȘI ÎNLOCUIȚII PENTRU TOATE SIMBOLULE, CU EXCEPȚIA SCATTERS <br>${imgBonusTrigger}`,
    wildReelPaytableMessage: (imgBonusTrigger?: string) => `WILD APARE PE TOATE RUBINETELE ȘI SE EXPANDEȘTE LA TOATE SIMBOLULE DE PE ACEEAȘI TOBINE ȘI ÎNLOCUIȚI PENTRU TOATE SIMBOLULE, CU EXCEPȚIA SCATTERS-URILOR <br>${imgBonusTrigger}`,
    StartingFreegamesHelp: (symbolsCount: number, startingFreegames: number, bonusWildSymbolContainer: string) => `DACĂ CÂȘTIGI ${bonusWildSymbolContainer} X ${symbolsCount} , TE VEI JUCA${startingFreegames} ROTARI GRATUITE.`,
    doubleUpTitle: `JOC DUBLĂ`,
    doubleUpHistoryTitle: `RECORD`,
    doubleUpLastCardTitle: `ULTIMUL CARTE`,
    doubleUpRedCardTxt: `ROȘU`,
    doubleUpBlackCardTxt: `NEGRU`,
    doubleUpCollectBtnTxt: `ADUNA TOTUL`,
    doubleUpRHalfBetBtnTxt: `TAXA JUMĂTATE`,
    doubleUpWinSign: `YOU WIN`,
    doubleUpLoseSign: `BETTER LUCK NEXT TIME`,
    doubleUpSelectedSign: `SELECTAT!`,
    doubleUpGainTxt: `ULTIMA CÂŞTIGĂ`,
    doubleUpCollectHalfTxt: `TAXA JUMĂTATE`,
    doubleUpCollectAllTxt: `ADUNA TOTUL`,
    doubleUpBetLimitSignTxt: `WIN LIMIT EXCEEDED! `,
    doubleUpWinLimitSignTxt: (winLimit: string) => `WIN LIMIT ${winLimit}`,
    doubleUpBetAndWinTxt: (bet, win) => `ALEGE CULOAREA ȘI PARIAZĂ ${bet} A CASTIGA ${win}`,
    doubleUpDescription: (winLimit: string) => `GUESS THE COLOR OF THE CARD THAT APPEARS IN THE MIDDLE. IF YOU DO IT YOU WOULD BE ABLE TO DOUBLE YOUR WIN, IF NOT, YOU LOSE EVERYTHING! IF IN THE NEXT ROUND YOUR WIN EXCEEDS ${winLimit} THEN THE CURRENT WIN WILL BE AUTOMATICALLY COLLECTED. YOU CAN COLLECT HALF OF YOUR BET IF YOU SELECT THE COLLECT HALF BUTTON OR COLLECT YOUR ENTIRE BET IF YOU SELECT COLLECT ALL BUTTON. IF YOU PRESS COLLECT ALL BUTTON OR YOU LOSE GAME ENDS`,


    doubleUpGameLimitTxt: (maxPicks) => `MAXIM ${maxPicks} ÎNCERCĂRI`,
    wildStackDescription: (imgBonusTrigger: string, reels: number[]) => `${imgBonusTrigger} PE SINE ${reels.join(", ")} \n ÎNLOCUIE TOATE SIMBOLULE`,
    grandJackpotMultiBonusDescription: (sraImg: string) => `TO WIN THE GRAND JACKPOT YOU NEED TU WIN 15 OR 30 OF ${sraImg} DEPENDING WHICH BONUS OR COMBINATION OF BONUSES YOU HAVE BEEN AWARDED`,

    spinandHoldInfoHelpFullAward: `TOATE PREȚURILE CARE APAR PE ECRAN VOR FI PLATITE`,
    WildStackFeature: `DOES NOT SUBSTITUE`,
    fillingPotTitle: `FILLING POT`,
    fillingPotDescription: `FILLING POT IS AN CUMULATIVE ANIMATION. THE MORE FULL OR COMPLETE IT ITS, THE CLOSER THE BONUS. EVERY BET KEEPS ITS OWN LEVEL OF ANIMATION. PLAYING THE GAME CAN INCREMENT THE LEVEL OF ANIMATION FOR THE BET PLAYED. WINNING THE BONUS RESETS THE ANIMATION TO THE START FOR THE BET PLAYED.`,

    //spinandHoldInfoHelpFullAward:`TOATE PREȚURILE CARE APAR PE ECRAN VOR FI PLATITE`,
    DialogIntroPixiBonus: (textSpanish, textEnglish) => { return textEnglish },
    DialogFinalPixiBonus: (textSpanish, textEnglish) => { return textEnglish },

    jackpotSharedDescription: `AMOUNT IN SHARED JACKPOT WILL BE DISTRIBUTED AMONG ALL THE PLAYERS PLAYING AT THE MOMENT OF WINNING THE MAIN JACKPOT PROPORTIONALY BASED ON THE LAST BET.`,

    bonusMultiplierDescription: `WHEN SHOW ON SCREEN NEXT STICKY BONUS WILL BE MULTIPLIER X2 OR X3 ALL BONUS WIN IF YOU CONTINUE ON SAME BET AND SAME DENOMINATION. THE JACKPOTS TO BE MULTIPLIED WILL BE MINOR AND MINI IF YOU GET THEM.`,
    bonusSpinsRemainingAndTotal: (from: number, to: number) => `Spin ${from} of ${to}`,
    portalBonusDescription: `IN THE PORTAL BONUS, SPECIAL SYMBOL “PORTAL” APPEAR.
    WHEN A PORTAL SYMBOL LANDS ON THE REELS, IT ACTIVATES THE PORTAL IN THAT POSITION.
    THE PORTAL ABSORBS ALL LOCKED SYMBOLS FROM THE OTHER REELS AND RELEASES THEM FOR NEW PRIZES.
    ALL THE VALUES OF THE ABSORBED SYMBOLS ARE ADDED TO THE PORTAL.
    THE PORTAL THEN BECOMES AN ACCUMULATED SYMBOL WITH THE TOTAL COMBINED VALUE.`,
    FillingGrandJackpotMultiBonusDescription: (sraImg: string) => `TO WIN THE GRAND JACKPOT
    \n  YOU NEED TO COLLECT 6 ${sraImg} GRAND  \n  
    ITS POSIBLE WIN 1 OR MORE GRAND JACKPOT IN THE SAME BONUS.`,
    buyBonusDisabledMessage: `IF THE BUY BONUS BUTTON IS GRAY YOU CAN'T BUY BONUS WITH THE SELECTED BET`,
    fillingJackpotMultiBonusDescription: (jackpots: HTMLSpanElement[]) =>
        `THERE ARE ${jackpots.length} JACKPOTS LEVELS: ${jackpots.filter(Boolean).map(jackpot => jackpot.outerHTML).join(", ")}.

    DURING THE BONUS, SRA JACKPOT SYMBOLS MAY APPEAR ON THE REELS.
    EACH SRA SYMBOL TURNS INTO A COMET THAT FLIES TO ITS JACKPOT AND FILLS ITS METER.
    
    EACH JACKPOT HAS DIFFERENT CONTAINERS TO FILL. WHEN YOU FILL THEM ALL: YOU WIN THAT JACKPOT! 
    THE REEL WHERE THE SRA SYMBOL LANDED IS RELEASED AND CAN KEEP GIVING MORE JACKPOTS OR PRIZES.
    
    YOU CAN WIN MULTIPLE JACKPOTS IN A SINGLE BONUS! `,
    symbolPayFeatureSRA: (count, bonusName) => `${count} OR MORE \n ACTIVATES THE BONUS ${bonusName}`,



}
/********************************************************************************************/

export type LanguageChangedCallback = (t: Translation) => void;

export type TranslationHandler = () => string;

export class TranslatedLocation {
    public readonly location: HTMLElement;
    public readonly translation: TranslationHandler;

    constructor(location: HTMLElement, translation: TranslationHandler) {
        this.location = location;
        this.translation = translation;
    }

    public Update(): void {
        this.location.innerHTML = this.translation();
    }
}

export class AvailableLanguage {
    public readonly name: string;
    public readonly nameEnglish: string;
    public readonly locality: string;
    public readonly localityShort: string;

    public constructor(translation: Translation) {
        this.name = translation.language;
        this.nameEnglish = translation.languageEnglish;
        this.locality = translation.locality;
        this.localityShort = translation.localityShort;
    }
}

type Writeable<T> = { -readonly [P in keyof T]: T[P] };

export class Translator {
    protected logGroup: LogGroup = new LogGroup("Translator");

    /** Current translation */
    public t: Translation = EnglishTranslation;

    /** All the locations where translation needs to be updated */
    protected translatedLocations: TranslatedLocation[] = [];

    /** key = locality */
    protected availableTranslations: Map<string, Translation> = new Map<string, Translation>();

    /** List of available translations loaded into translator */
    public readonly availableLanguages: AvailableLanguage[] = [];

    /** */
    protected defaultLocality: string = null;

    protected translationLocationFreeze: boolean = false;

    private languageCahangedCallbacks: LanguageChangedCallback[] = []
    public SetOnLanguageChangedCallback(callback: LanguageChangedCallback) {
        this.languageCahangedCallbacks.push(callback);
    }


    public constructor(enabledTranslations: Translation[]) {
        this.defaultLocality = enabledTranslations[0].locality;
        enabledTranslations.forEach(t => this.LoadTranslation(t));

        void this.ChangeLanguage(this.defaultLocality);
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager): void {

    }

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager): void {

    }

    public NoMoreLoading(resourceManager: ResourceManager): void {
        this.translationLocationFreeze = true;
    }

    /**
     * Add new translation to the translator
     * @param translation
     */
    public LoadTranslation(translation: Translation) {
        if (!this.availableTranslations.has(translation.locality)) {
            this.availableTranslations.set(translation.locality, translation);
            this.availableLanguages.push(new AvailableLanguage(translation));
        }
        else {
            // duplicate translation
        }
    }

    public AvailableLanguages(): AvailableLanguage[] {
        return this.availableLanguages;
    }

    /**
     * 
     * @param locality Change language to specific locality
     */

    private currentTaskCancellation: { cancel: boolean } = { cancel: false };
    public async ChangeLanguage(locality: string) {
        // Cancel the previous task if it exists
        this.currentTaskCancellation.cancel = true;
        this.currentTaskCancellation = { cancel: false };
        const cancellation = this.currentTaskCancellation;

        // try to find translation for given locality
        let newTranslation = [...this.availableTranslations.values()].find(t =>
            t.locality.toLowerCase() == locality.toLowerCase() ||
            t.localityShort.toLowerCase() == locality.toLowerCase()
        );

        if (!newTranslation) {
            // Log.Debug(this.logGroup, "Translation for locality " + locality + " does not exist, using default " + this.defaultLocality);

            // translation does not exist, use default
            newTranslation = this.availableTranslations.get(this.defaultLocality);
        }

        // refresh texts, when language has changed
        if (newTranslation.locality == this.t.locality) {
            return;
        }

        (this.t as Writeable<Translation>) = newTranslation;
        let startTime = performance.now();

        for (let i = 0; i < this.languageCahangedCallbacks.length; i++) {
            if (cancellation.cancel) return;

            this.languageCahangedCallbacks[i](this.t);

            // Check elapsed time
            let elapsedTime = performance.now() - startTime;
            if (elapsedTime >= 16.67) {
                await Delay(0); // Wait for the next frame
                startTime = performance.now();
            }
        }

        for (let i = 0; i < this.translatedLocations.length; i++) {
            if (cancellation.cancel) return;

            this.translatedLocations[i].Update();

            // Check elapsed time
            let elapsedTime = performance.now() - startTime;
            if (elapsedTime >= 16.67) {
                await Delay(0); // Wait for the next frame
                startTime = performance.now();
            }
        }
    }

    public NextLanguage(): void {
        let allLanguages: string[] = Array.from(this.availableTranslations.keys());

        let currentIndexLanguage: number = allLanguages.indexOf(this.t.locality);

        let newIndexLanguage = (currentIndexLanguage + 1) % allLanguages.length;

        void this.ChangeLanguage(allLanguages[newIndexLanguage]);
    }

    public ResetToDefault(): void {
        void this.ChangeLanguage(this.defaultLocality);
    }


    /**
     * Used when appending translated text to other element
     * @param translationHandler 
     */
    public Anchor(translationHandler: TranslationHandler): HTMLElement {
        if (this.translationLocationFreeze) {
            Log.Error(this.logGroup, "All resources are loaded, appending not allowed, possible memory leak");
            throw "All resources are loaded, appending not allowed, possible memory leak";
        }

        let translatedLocation: TranslatedLocation = this.Translate(translationHandler);
        this.translatedLocations.push(translatedLocation);
        return translatedLocation.location;
    }

    /**
     * Used when only getting the translation, and appending it later
     * @param translationHandler 
     */
    public Translate(translationHandler: TranslationHandler): TranslatedLocation {
        if (this.translationLocationFreeze) {
            Log.Error(this.logGroup, "All resources are loaded, appending not allowed, possible memory leak");
            throw "All resources are loaded, appending not allowed, possible memory leak";
        }

        let elem: HTMLElement = document.createElement("span");
        elem.innerHTML = translationHandler();
        let location = new TranslatedLocation(elem, translationHandler);

        this.translatedLocations.push(location);
        return location;
    }


}



export const AvailableTransations = [
    "romanian",
    "spanish",
    "english"
] as const;

export type OneOfTranslations = (typeof AvailableTransations)[number];

export const translationMap =
{
    "romanian": RomanianTranslation,
    "spanish": SpanishTranslation,
    "english": EnglishTranslation,
}

function transformNameBonus(CurrentTranslation: string, BonusName: string): string {
    if (CurrentTranslation == RomanianTranslation.language) {
        BonusName = "JocGratis";
    }
    else if (CurrentTranslation == SpanishTranslation.language) {
        BonusName = "JuegoGratis";

    }
    return BonusName.replace(/([A-Z])/g, ' $1').trim();

}
